"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    solid: [
        {
            name: 'ad',
            unicode: 'f641'
        },
        {
            name: 'address-book',
            unicode: 'f2b9'
        },
        {
            name: 'address-card',
            unicode: 'f2bb'
        },
        {
            name: 'adjust',
            unicode: 'f042'
        },
        {
            name: 'air-freshener',
            unicode: 'f5d0'
        },
        {
            name: 'align-center',
            unicode: 'f037'
        },
        {
            name: 'align-justify',
            unicode: 'f039'
        },
        {
            name: 'align-left',
            unicode: 'f036'
        },
        {
            name: 'align-right',
            unicode: 'f038'
        },
        {
            name: 'allergies',
            unicode: 'f461'
        },
        {
            name: 'ambulance',
            unicode: 'f0f9'
        },
        {
            name: 'american-sign-language-interpreting',
            unicode: 'f2a3'
        },
        {
            name: 'anchor',
            unicode: 'f13d'
        },
        {
            name: 'angle-double-down',
            unicode: 'f103'
        },
        {
            name: 'angle-double-left',
            unicode: 'f100'
        },
        {
            name: 'angle-double-right',
            unicode: 'f101'
        },
        {
            name: 'angle-double-up',
            unicode: 'f102'
        },
        {
            name: 'angle-down',
            unicode: 'f107'
        },
        {
            name: 'angle-left',
            unicode: 'f104'
        },
        {
            name: 'angle-right',
            unicode: 'f105'
        },
        {
            name: 'angle-up',
            unicode: 'f106'
        },
        {
            name: 'angry',
            unicode: 'f556'
        },
        {
            name: 'ankh',
            unicode: 'f644'
        },
        {
            name: 'apple-alt',
            unicode: 'f5d1'
        },
        {
            name: 'archive',
            unicode: 'f187'
        },
        {
            name: 'archway',
            unicode: 'f557'
        },
        {
            name: 'arrow-alt-circle-down',
            unicode: 'f358'
        },
        {
            name: 'arrow-alt-circle-left',
            unicode: 'f359'
        },
        {
            name: 'arrow-alt-circle-right',
            unicode: 'f35a'
        },
        {
            name: 'arrow-alt-circle-up',
            unicode: 'f35b'
        },
        {
            name: 'arrow-circle-down',
            unicode: 'f0ab'
        },
        {
            name: 'arrow-circle-left',
            unicode: 'f0a8'
        },
        {
            name: 'arrow-circle-right',
            unicode: 'f0a9'
        },
        {
            name: 'arrow-circle-up',
            unicode: 'f0aa'
        },
        {
            name: 'arrow-down',
            unicode: 'f063'
        },
        {
            name: 'arrow-left',
            unicode: 'f060'
        },
        {
            name: 'arrow-right',
            unicode: 'f061'
        },
        {
            name: 'arrow-up',
            unicode: 'f062'
        },
        {
            name: 'arrows-alt',
            unicode: 'f0b2'
        },
        {
            name: 'arrows-alt-h',
            unicode: 'f337'
        },
        {
            name: 'arrows-alt-v',
            unicode: 'f338'
        },
        {
            name: 'assistive-listening-systems',
            unicode: 'f2a2'
        },
        {
            name: 'asterisk',
            unicode: 'f069'
        },
        {
            name: 'at',
            unicode: 'f1fa'
        },
        {
            name: 'atlas',
            unicode: 'f558'
        },
        {
            name: 'atom',
            unicode: 'f5d2'
        },
        {
            name: 'audio-description',
            unicode: 'f29e'
        },
        {
            name: 'award',
            unicode: 'f559'
        },
        {
            name: 'baby',
            unicode: 'f77c'
        },
        {
            name: 'baby-carriage',
            unicode: 'f77d'
        },
        {
            name: 'backspace',
            unicode: 'f55a'
        },
        {
            name: 'backward',
            unicode: 'f04a'
        },
        {
            name: 'bacon',
            unicode: 'f7e5'
        },
        {
            name: 'bacteria',
            unicode: 'e059'
        },
        {
            name: 'bacterium',
            unicode: 'e05a'
        },
        {
            name: 'bahai',
            unicode: 'f666'
        },
        {
            name: 'balance-scale',
            unicode: 'f24e'
        },
        {
            name: 'balance-scale-left',
            unicode: 'f515'
        },
        {
            name: 'balance-scale-right',
            unicode: 'f516'
        },
        {
            name: 'ban',
            unicode: 'f05e'
        },
        {
            name: 'band-aid',
            unicode: 'f462'
        },
        {
            name: 'barcode',
            unicode: 'f02a'
        },
        {
            name: 'bars',
            unicode: 'f0c9'
        },
        {
            name: 'baseball-ball',
            unicode: 'f433'
        },
        {
            name: 'basketball-ball',
            unicode: 'f434'
        },
        {
            name: 'bath',
            unicode: 'f2cd'
        },
        {
            name: 'battery-empty',
            unicode: 'f244'
        },
        {
            name: 'battery-full',
            unicode: 'f240'
        },
        {
            name: 'battery-half',
            unicode: 'f242'
        },
        {
            name: 'battery-quarter',
            unicode: 'f243'
        },
        {
            name: 'battery-three-quarters',
            unicode: 'f241'
        },
        {
            name: 'bed',
            unicode: 'f236'
        },
        {
            name: 'beer',
            unicode: 'f0fc'
        },
        {
            name: 'bell',
            unicode: 'f0f3'
        },
        {
            name: 'bell-slash',
            unicode: 'f1f6'
        },
        {
            name: 'bezier-curve',
            unicode: 'f55b'
        },
        {
            name: 'bible',
            unicode: 'f647'
        },
        {
            name: 'bicycle',
            unicode: 'f206'
        },
        {
            name: 'biking',
            unicode: 'f84a'
        },
        {
            name: 'binoculars',
            unicode: 'f1e5'
        },
        {
            name: 'biohazard',
            unicode: 'f780'
        },
        {
            name: 'birthday-cake',
            unicode: 'f1fd'
        },
        {
            name: 'blender',
            unicode: 'f517'
        },
        {
            name: 'blender-phone',
            unicode: 'f6b6'
        },
        {
            name: 'blind',
            unicode: 'f29d'
        },
        {
            name: 'blog',
            unicode: 'f781'
        },
        {
            name: 'bold',
            unicode: 'f032'
        },
        {
            name: 'bolt',
            unicode: 'f0e7'
        },
        {
            name: 'bomb',
            unicode: 'f1e2'
        },
        {
            name: 'bone',
            unicode: 'f5d7'
        },
        {
            name: 'bong',
            unicode: 'f55c'
        },
        {
            name: 'book',
            unicode: 'f02d'
        },
        {
            name: 'book-dead',
            unicode: 'f6b7'
        },
        {
            name: 'book-medical',
            unicode: 'f7e6'
        },
        {
            name: 'book-open',
            unicode: 'f518'
        },
        {
            name: 'book-reader',
            unicode: 'f5da'
        },
        {
            name: 'bookmark',
            unicode: 'f02e'
        },
        {
            name: 'border-all',
            unicode: 'f84c'
        },
        {
            name: 'border-none',
            unicode: 'f850'
        },
        {
            name: 'border-style',
            unicode: 'f853'
        },
        {
            name: 'bowling-ball',
            unicode: 'f436'
        },
        {
            name: 'box',
            unicode: 'f466'
        },
        {
            name: 'box-open',
            unicode: 'f49e'
        },
        {
            name: 'box-tissue',
            unicode: 'e05b'
        },
        {
            name: 'boxes',
            unicode: 'f468'
        },
        {
            name: 'braille',
            unicode: 'f2a1'
        },
        {
            name: 'brain',
            unicode: 'f5dc'
        },
        {
            name: 'bread-slice',
            unicode: 'f7ec'
        },
        {
            name: 'briefcase',
            unicode: 'f0b1'
        },
        {
            name: 'briefcase-medical',
            unicode: 'f469'
        },
        {
            name: 'broadcast-tower',
            unicode: 'f519'
        },
        {
            name: 'broom',
            unicode: 'f51a'
        },
        {
            name: 'brush',
            unicode: 'f55d'
        },
        {
            name: 'bug',
            unicode: 'f188'
        },
        {
            name: 'building',
            unicode: 'f1ad'
        },
        {
            name: 'bullhorn',
            unicode: 'f0a1'
        },
        {
            name: 'bullseye',
            unicode: 'f140'
        },
        {
            name: 'burn',
            unicode: 'f46a'
        },
        {
            name: 'bus',
            unicode: 'f207'
        },
        {
            name: 'bus-alt',
            unicode: 'f55e'
        },
        {
            name: 'business-time',
            unicode: 'f64a'
        },
        {
            name: 'calculator',
            unicode: 'f1ec'
        },
        {
            name: 'calendar',
            unicode: 'f133'
        },
        {
            name: 'calendar-alt',
            unicode: 'f073'
        },
        {
            name: 'calendar-check',
            unicode: 'f274'
        },
        {
            name: 'calendar-day',
            unicode: 'f783'
        },
        {
            name: 'calendar-minus',
            unicode: 'f272'
        },
        {
            name: 'calendar-plus',
            unicode: 'f271'
        },
        {
            name: 'calendar-times',
            unicode: 'f273'
        },
        {
            name: 'calendar-week',
            unicode: 'f784'
        },
        {
            name: 'camera',
            unicode: 'f030'
        },
        {
            name: 'camera-retro',
            unicode: 'f083'
        },
        {
            name: 'campground',
            unicode: 'f6bb'
        },
        {
            name: 'candy-cane',
            unicode: 'f786'
        },
        {
            name: 'cannabis',
            unicode: 'f55f'
        },
        {
            name: 'capsules',
            unicode: 'f46b'
        },
        {
            name: 'car',
            unicode: 'f1b9'
        },
        {
            name: 'car-alt',
            unicode: 'f5de'
        },
        {
            name: 'car-battery',
            unicode: 'f5df'
        },
        {
            name: 'car-crash',
            unicode: 'f5e1'
        },
        {
            name: 'car-side',
            unicode: 'f5e4'
        },
        {
            name: 'caravan',
            unicode: 'f8ff'
        },
        {
            name: 'caret-down',
            unicode: 'f0d7'
        },
        {
            name: 'caret-left',
            unicode: 'f0d9'
        },
        {
            name: 'caret-right',
            unicode: 'f0da'
        },
        {
            name: 'caret-square-down',
            unicode: 'f150'
        },
        {
            name: 'caret-square-left',
            unicode: 'f191'
        },
        {
            name: 'caret-square-right',
            unicode: 'f152'
        },
        {
            name: 'caret-square-up',
            unicode: 'f151'
        },
        {
            name: 'caret-up',
            unicode: 'f0d8'
        },
        {
            name: 'carrot',
            unicode: 'f787'
        },
        {
            name: 'cart-arrow-down',
            unicode: 'f218'
        },
        {
            name: 'cart-plus',
            unicode: 'f217'
        },
        {
            name: 'cash-register',
            unicode: 'f788'
        },
        {
            name: 'cat',
            unicode: 'f6be'
        },
        {
            name: 'certificate',
            unicode: 'f0a3'
        },
        {
            name: 'chair',
            unicode: 'f6c0'
        },
        {
            name: 'chalkboard',
            unicode: 'f51b'
        },
        {
            name: 'chalkboard-teacher',
            unicode: 'f51c'
        },
        {
            name: 'charging-station',
            unicode: 'f5e7'
        },
        {
            name: 'chart-area',
            unicode: 'f1fe'
        },
        {
            name: 'chart-bar',
            unicode: 'f080'
        },
        {
            name: 'chart-line',
            unicode: 'f201'
        },
        {
            name: 'chart-pie',
            unicode: 'f200'
        },
        {
            name: 'check',
            unicode: 'f00c'
        },
        {
            name: 'check-circle',
            unicode: 'f058'
        },
        {
            name: 'check-double',
            unicode: 'f560'
        },
        {
            name: 'check-square',
            unicode: 'f14a'
        },
        {
            name: 'cheese',
            unicode: 'f7ef'
        },
        {
            name: 'chess',
            unicode: 'f439'
        },
        {
            name: 'chess-bishop',
            unicode: 'f43a'
        },
        {
            name: 'chess-board',
            unicode: 'f43c'
        },
        {
            name: 'chess-king',
            unicode: 'f43f'
        },
        {
            name: 'chess-knight',
            unicode: 'f441'
        },
        {
            name: 'chess-pawn',
            unicode: 'f443'
        },
        {
            name: 'chess-queen',
            unicode: 'f445'
        },
        {
            name: 'chess-rook',
            unicode: 'f447'
        },
        {
            name: 'chevron-circle-down',
            unicode: 'f13a'
        },
        {
            name: 'chevron-circle-left',
            unicode: 'f137'
        },
        {
            name: 'chevron-circle-right',
            unicode: 'f138'
        },
        {
            name: 'chevron-circle-up',
            unicode: 'f139'
        },
        {
            name: 'chevron-down',
            unicode: 'f078'
        },
        {
            name: 'chevron-left',
            unicode: 'f053'
        },
        {
            name: 'chevron-right',
            unicode: 'f054'
        },
        {
            name: 'chevron-up',
            unicode: 'f077'
        },
        {
            name: 'child',
            unicode: 'f1ae'
        },
        {
            name: 'church',
            unicode: 'f51d'
        },
        {
            name: 'circle',
            unicode: 'f111'
        },
        {
            name: 'circle-notch',
            unicode: 'f1ce'
        },
        {
            name: 'city',
            unicode: 'f64f'
        },
        {
            name: 'clinic-medical',
            unicode: 'f7f2'
        },
        {
            name: 'clipboard',
            unicode: 'f328'
        },
        {
            name: 'clipboard-check',
            unicode: 'f46c'
        },
        {
            name: 'clipboard-list',
            unicode: 'f46d'
        },
        {
            name: 'clock',
            unicode: 'f017'
        },
        {
            name: 'clone',
            unicode: 'f24d'
        },
        {
            name: 'closed-captioning',
            unicode: 'f20a'
        },
        {
            name: 'cloud',
            unicode: 'f0c2'
        },
        {
            name: 'cloud-download-alt',
            unicode: 'f381'
        },
        {
            name: 'cloud-meatball',
            unicode: 'f73b'
        },
        {
            name: 'cloud-moon',
            unicode: 'f6c3'
        },
        {
            name: 'cloud-moon-rain',
            unicode: 'f73c'
        },
        {
            name: 'cloud-rain',
            unicode: 'f73d'
        },
        {
            name: 'cloud-showers-heavy',
            unicode: 'f740'
        },
        {
            name: 'cloud-sun',
            unicode: 'f6c4'
        },
        {
            name: 'cloud-sun-rain',
            unicode: 'f743'
        },
        {
            name: 'cloud-upload-alt',
            unicode: 'f382'
        },
        {
            name: 'cocktail',
            unicode: 'f561'
        },
        {
            name: 'code',
            unicode: 'f121'
        },
        {
            name: 'code-branch',
            unicode: 'f126'
        },
        {
            name: 'coffee',
            unicode: 'f0f4'
        },
        {
            name: 'cog',
            unicode: 'f013'
        },
        {
            name: 'cogs',
            unicode: 'f085'
        },
        {
            name: 'coins',
            unicode: 'f51e'
        },
        {
            name: 'columns',
            unicode: 'f0db'
        },
        {
            name: 'comment',
            unicode: 'f075'
        },
        {
            name: 'comment-alt',
            unicode: 'f27a'
        },
        {
            name: 'comment-dollar',
            unicode: 'f651'
        },
        {
            name: 'comment-dots',
            unicode: 'f4ad'
        },
        {
            name: 'comment-medical',
            unicode: 'f7f5'
        },
        {
            name: 'comment-slash',
            unicode: 'f4b3'
        },
        {
            name: 'comments',
            unicode: 'f086'
        },
        {
            name: 'comments-dollar',
            unicode: 'f653'
        },
        {
            name: 'compact-disc',
            unicode: 'f51f'
        },
        {
            name: 'compass',
            unicode: 'f14e'
        },
        {
            name: 'compress',
            unicode: 'f066'
        },
        {
            name: 'compress-alt',
            unicode: 'f422'
        },
        {
            name: 'compress-arrows-alt',
            unicode: 'f78c'
        },
        {
            name: 'concierge-bell',
            unicode: 'f562'
        },
        {
            name: 'cookie',
            unicode: 'f563'
        },
        {
            name: 'cookie-bite',
            unicode: 'f564'
        },
        {
            name: 'copy',
            unicode: 'f0c5'
        },
        {
            name: 'copyright',
            unicode: 'f1f9'
        },
        {
            name: 'couch',
            unicode: 'f4b8'
        },
        {
            name: 'credit-card',
            unicode: 'f09d'
        },
        {
            name: 'crop',
            unicode: 'f125'
        },
        {
            name: 'crop-alt',
            unicode: 'f565'
        },
        {
            name: 'cross',
            unicode: 'f654'
        },
        {
            name: 'crosshairs',
            unicode: 'f05b'
        },
        {
            name: 'crow',
            unicode: 'f520'
        },
        {
            name: 'crown',
            unicode: 'f521'
        },
        {
            name: 'crutch',
            unicode: 'f7f7'
        },
        {
            name: 'cube',
            unicode: 'f1b2'
        },
        {
            name: 'cubes',
            unicode: 'f1b3'
        },
        {
            name: 'cut',
            unicode: 'f0c4'
        },
        {
            name: 'database',
            unicode: 'f1c0'
        },
        {
            name: 'deaf',
            unicode: 'f2a4'
        },
        {
            name: 'democrat',
            unicode: 'f747'
        },
        {
            name: 'desktop',
            unicode: 'f108'
        },
        {
            name: 'dharmachakra',
            unicode: 'f655'
        },
        {
            name: 'diagnoses',
            unicode: 'f470'
        },
        {
            name: 'dice',
            unicode: 'f522'
        },
        {
            name: 'dice-d20',
            unicode: 'f6cf'
        },
        {
            name: 'dice-d6',
            unicode: 'f6d1'
        },
        {
            name: 'dice-five',
            unicode: 'f523'
        },
        {
            name: 'dice-four',
            unicode: 'f524'
        },
        {
            name: 'dice-one',
            unicode: 'f525'
        },
        {
            name: 'dice-six',
            unicode: 'f526'
        },
        {
            name: 'dice-three',
            unicode: 'f527'
        },
        {
            name: 'dice-two',
            unicode: 'f528'
        },
        {
            name: 'digital-tachograph',
            unicode: 'f566'
        },
        {
            name: 'directions',
            unicode: 'f5eb'
        },
        {
            name: 'disease',
            unicode: 'f7fa'
        },
        {
            name: 'divide',
            unicode: 'f529'
        },
        {
            name: 'dizzy',
            unicode: 'f567'
        },
        {
            name: 'dna',
            unicode: 'f471'
        },
        {
            name: 'dog',
            unicode: 'f6d3'
        },
        {
            name: 'dollar-sign',
            unicode: 'f155'
        },
        {
            name: 'dolly',
            unicode: 'f472'
        },
        {
            name: 'dolly-flatbed',
            unicode: 'f474'
        },
        {
            name: 'donate',
            unicode: 'f4b9'
        },
        {
            name: 'door-closed',
            unicode: 'f52a'
        },
        {
            name: 'door-open',
            unicode: 'f52b'
        },
        {
            name: 'dot-circle',
            unicode: 'f192'
        },
        {
            name: 'dove',
            unicode: 'f4ba'
        },
        {
            name: 'download',
            unicode: 'f019'
        },
        {
            name: 'drafting-compass',
            unicode: 'f568'
        },
        {
            name: 'dragon',
            unicode: 'f6d5'
        },
        {
            name: 'draw-polygon',
            unicode: 'f5ee'
        },
        {
            name: 'drum',
            unicode: 'f569'
        },
        {
            name: 'drum-steelpan',
            unicode: 'f56a'
        },
        {
            name: 'drumstick-bite',
            unicode: 'f6d7'
        },
        {
            name: 'dumbbell',
            unicode: 'f44b'
        },
        {
            name: 'dumpster',
            unicode: 'f793'
        },
        {
            name: 'dumpster-fire',
            unicode: 'f794'
        },
        {
            name: 'dungeon',
            unicode: 'f6d9'
        },
        {
            name: 'edit',
            unicode: 'f044'
        },
        {
            name: 'egg',
            unicode: 'f7fb'
        },
        {
            name: 'eject',
            unicode: 'f052'
        },
        {
            name: 'ellipsis-h',
            unicode: 'f141'
        },
        {
            name: 'ellipsis-v',
            unicode: 'f142'
        },
        {
            name: 'envelope',
            unicode: 'f0e0'
        },
        {
            name: 'envelope-open',
            unicode: 'f2b6'
        },
        {
            name: 'envelope-open-text',
            unicode: 'f658'
        },
        {
            name: 'envelope-square',
            unicode: 'f199'
        },
        {
            name: 'equals',
            unicode: 'f52c'
        },
        {
            name: 'eraser',
            unicode: 'f12d'
        },
        {
            name: 'ethernet',
            unicode: 'f796'
        },
        {
            name: 'euro-sign',
            unicode: 'f153'
        },
        {
            name: 'exchange-alt',
            unicode: 'f362'
        },
        {
            name: 'exclamation',
            unicode: 'f12a'
        },
        {
            name: 'exclamation-circle',
            unicode: 'f06a'
        },
        {
            name: 'exclamation-triangle',
            unicode: 'f071'
        },
        {
            name: 'expand',
            unicode: 'f065'
        },
        {
            name: 'expand-alt',
            unicode: 'f424'
        },
        {
            name: 'expand-arrows-alt',
            unicode: 'f31e'
        },
        {
            name: 'external-link-alt',
            unicode: 'f35d'
        },
        {
            name: 'external-link-square-alt',
            unicode: 'f360'
        },
        {
            name: 'eye',
            unicode: 'f06e'
        },
        {
            name: 'eye-dropper',
            unicode: 'f1fb'
        },
        {
            name: 'eye-slash',
            unicode: 'f070'
        },
        {
            name: 'fan',
            unicode: 'f863'
        },
        {
            name: 'fast-backward',
            unicode: 'f049'
        },
        {
            name: 'fast-forward',
            unicode: 'f050'
        },
        {
            name: 'faucet',
            unicode: 'e005'
        },
        {
            name: 'fax',
            unicode: 'f1ac'
        },
        {
            name: 'feather',
            unicode: 'f52d'
        },
        {
            name: 'feather-alt',
            unicode: 'f56b'
        },
        {
            name: 'female',
            unicode: 'f182'
        },
        {
            name: 'fighter-jet',
            unicode: 'f0fb'
        },
        {
            name: 'file',
            unicode: 'f15b'
        },
        {
            name: 'file-alt',
            unicode: 'f15c'
        },
        {
            name: 'file-archive',
            unicode: 'f1c6'
        },
        {
            name: 'file-audio',
            unicode: 'f1c7'
        },
        {
            name: 'file-code',
            unicode: 'f1c9'
        },
        {
            name: 'file-contract',
            unicode: 'f56c'
        },
        {
            name: 'file-csv',
            unicode: 'f6dd'
        },
        {
            name: 'file-download',
            unicode: 'f56d'
        },
        {
            name: 'file-excel',
            unicode: 'f1c3'
        },
        {
            name: 'file-export',
            unicode: 'f56e'
        },
        {
            name: 'file-image',
            unicode: 'f1c5'
        },
        {
            name: 'file-import',
            unicode: 'f56f'
        },
        {
            name: 'file-invoice',
            unicode: 'f570'
        },
        {
            name: 'file-invoice-dollar',
            unicode: 'f571'
        },
        {
            name: 'file-medical',
            unicode: 'f477'
        },
        {
            name: 'file-medical-alt',
            unicode: 'f478'
        },
        {
            name: 'file-pdf',
            unicode: 'f1c1'
        },
        {
            name: 'file-powerpoint',
            unicode: 'f1c4'
        },
        {
            name: 'file-prescription',
            unicode: 'f572'
        },
        {
            name: 'file-signature',
            unicode: 'f573'
        },
        {
            name: 'file-upload',
            unicode: 'f574'
        },
        {
            name: 'file-video',
            unicode: 'f1c8'
        },
        {
            name: 'file-word',
            unicode: 'f1c2'
        },
        {
            name: 'fill',
            unicode: 'f575'
        },
        {
            name: 'fill-drip',
            unicode: 'f576'
        },
        {
            name: 'film',
            unicode: 'f008'
        },
        {
            name: 'filter',
            unicode: 'f0b0'
        },
        {
            name: 'fingerprint',
            unicode: 'f577'
        },
        {
            name: 'fire',
            unicode: 'f06d'
        },
        {
            name: 'fire-alt',
            unicode: 'f7e4'
        },
        {
            name: 'fire-extinguisher',
            unicode: 'f134'
        },
        {
            name: 'first-aid',
            unicode: 'f479'
        },
        {
            name: 'fish',
            unicode: 'f578'
        },
        {
            name: 'fist-raised',
            unicode: 'f6de'
        },
        {
            name: 'flag',
            unicode: 'f024'
        },
        {
            name: 'flag-checkered',
            unicode: 'f11e'
        },
        {
            name: 'flag-usa',
            unicode: 'f74d'
        },
        {
            name: 'flask',
            unicode: 'f0c3'
        },
        {
            name: 'flushed',
            unicode: 'f579'
        },
        {
            name: 'folder',
            unicode: 'f07b'
        },
        {
            name: 'folder-minus',
            unicode: 'f65d'
        },
        {
            name: 'folder-open',
            unicode: 'f07c'
        },
        {
            name: 'folder-plus',
            unicode: 'f65e'
        },
        {
            name: 'font',
            unicode: 'f031'
        },
        {
            name: 'font-awesome-logo-full',
            unicode: 'f4e6'
        },
        {
            name: 'football-ball',
            unicode: 'f44e'
        },
        {
            name: 'forward',
            unicode: 'f04e'
        },
        {
            name: 'frog',
            unicode: 'f52e'
        },
        {
            name: 'frown',
            unicode: 'f119'
        },
        {
            name: 'frown-open',
            unicode: 'f57a'
        },
        {
            name: 'funnel-dollar',
            unicode: 'f662'
        },
        {
            name: 'futbol',
            unicode: 'f1e3'
        },
        {
            name: 'gamepad',
            unicode: 'f11b'
        },
        {
            name: 'gas-pump',
            unicode: 'f52f'
        },
        {
            name: 'gavel',
            unicode: 'f0e3'
        },
        {
            name: 'gem',
            unicode: 'f3a5'
        },
        {
            name: 'genderless',
            unicode: 'f22d'
        },
        {
            name: 'ghost',
            unicode: 'f6e2'
        },
        {
            name: 'gift',
            unicode: 'f06b'
        },
        {
            name: 'gifts',
            unicode: 'f79c'
        },
        {
            name: 'glass-cheers',
            unicode: 'f79f'
        },
        {
            name: 'glass-martini',
            unicode: 'f000'
        },
        {
            name: 'glass-martini-alt',
            unicode: 'f57b'
        },
        {
            name: 'glass-whiskey',
            unicode: 'f7a0'
        },
        {
            name: 'glasses',
            unicode: 'f530'
        },
        {
            name: 'globe',
            unicode: 'f0ac'
        },
        {
            name: 'globe-africa',
            unicode: 'f57c'
        },
        {
            name: 'globe-americas',
            unicode: 'f57d'
        },
        {
            name: 'globe-asia',
            unicode: 'f57e'
        },
        {
            name: 'globe-europe',
            unicode: 'f7a2'
        },
        {
            name: 'golf-ball',
            unicode: 'f450'
        },
        {
            name: 'gopuram',
            unicode: 'f664'
        },
        {
            name: 'graduation-cap',
            unicode: 'f19d'
        },
        {
            name: 'greater-than',
            unicode: 'f531'
        },
        {
            name: 'greater-than-equal',
            unicode: 'f532'
        },
        {
            name: 'grimace',
            unicode: 'f57f'
        },
        {
            name: 'grin',
            unicode: 'f580'
        },
        {
            name: 'grin-alt',
            unicode: 'f581'
        },
        {
            name: 'grin-beam',
            unicode: 'f582'
        },
        {
            name: 'grin-beam-sweat',
            unicode: 'f583'
        },
        {
            name: 'grin-hearts',
            unicode: 'f584'
        },
        {
            name: 'grin-squint',
            unicode: 'f585'
        },
        {
            name: 'grin-squint-tears',
            unicode: 'f586'
        },
        {
            name: 'grin-stars',
            unicode: 'f587'
        },
        {
            name: 'grin-tears',
            unicode: 'f588'
        },
        {
            name: 'grin-tongue',
            unicode: 'f589'
        },
        {
            name: 'grin-tongue-squint',
            unicode: 'f58a'
        },
        {
            name: 'grin-tongue-wink',
            unicode: 'f58b'
        },
        {
            name: 'grin-wink',
            unicode: 'f58c'
        },
        {
            name: 'grip-horizontal',
            unicode: 'f58d'
        },
        {
            name: 'grip-lines',
            unicode: 'f7a4'
        },
        {
            name: 'grip-lines-vertical',
            unicode: 'f7a5'
        },
        {
            name: 'grip-vertical',
            unicode: 'f58e'
        },
        {
            name: 'guitar',
            unicode: 'f7a6'
        },
        {
            name: 'h-square',
            unicode: 'f0fd'
        },
        {
            name: 'hamburger',
            unicode: 'f805'
        },
        {
            name: 'hammer',
            unicode: 'f6e3'
        },
        {
            name: 'hamsa',
            unicode: 'f665'
        },
        {
            name: 'hand-holding',
            unicode: 'f4bd'
        },
        {
            name: 'hand-holding-heart',
            unicode: 'f4be'
        },
        {
            name: 'hand-holding-medical',
            unicode: 'e05c'
        },
        {
            name: 'hand-holding-usd',
            unicode: 'f4c0'
        },
        {
            name: 'hand-holding-water',
            unicode: 'f4c1'
        },
        {
            name: 'hand-lizard',
            unicode: 'f258'
        },
        {
            name: 'hand-middle-finger',
            unicode: 'f806'
        },
        {
            name: 'hand-paper',
            unicode: 'f256'
        },
        {
            name: 'hand-peace',
            unicode: 'f25b'
        },
        {
            name: 'hand-point-down',
            unicode: 'f0a7'
        },
        {
            name: 'hand-point-left',
            unicode: 'f0a5'
        },
        {
            name: 'hand-point-right',
            unicode: 'f0a4'
        },
        {
            name: 'hand-point-up',
            unicode: 'f0a6'
        },
        {
            name: 'hand-pointer',
            unicode: 'f25a'
        },
        {
            name: 'hand-rock',
            unicode: 'f255'
        },
        {
            name: 'hand-scissors',
            unicode: 'f257'
        },
        {
            name: 'hand-sparkles',
            unicode: 'e05d'
        },
        {
            name: 'hand-spock',
            unicode: 'f259'
        },
        {
            name: 'hands',
            unicode: 'f4c2'
        },
        {
            name: 'hands-helping',
            unicode: 'f4c4'
        },
        {
            name: 'hands-wash',
            unicode: 'e05e'
        },
        {
            name: 'handshake',
            unicode: 'f2b5'
        },
        {
            name: 'handshake-alt-slash',
            unicode: 'e05f'
        },
        {
            name: 'handshake-slash',
            unicode: 'e060'
        },
        {
            name: 'hanukiah',
            unicode: 'f6e6'
        },
        {
            name: 'hard-hat',
            unicode: 'f807'
        },
        {
            name: 'hashtag',
            unicode: 'f292'
        },
        {
            name: 'hat-cowboy',
            unicode: 'f8c0'
        },
        {
            name: 'hat-cowboy-side',
            unicode: 'f8c1'
        },
        {
            name: 'hat-wizard',
            unicode: 'f6e8'
        },
        {
            name: 'hdd',
            unicode: 'f0a0'
        },
        {
            name: 'head-side-cough',
            unicode: 'e061'
        },
        {
            name: 'head-side-cough-slash',
            unicode: 'e062'
        },
        {
            name: 'head-side-mask',
            unicode: 'e063'
        },
        {
            name: 'head-side-virus',
            unicode: 'e064'
        },
        {
            name: 'heading',
            unicode: 'f1dc'
        },
        {
            name: 'headphones',
            unicode: 'f025'
        },
        {
            name: 'headphones-alt',
            unicode: 'f58f'
        },
        {
            name: 'headset',
            unicode: 'f590'
        },
        {
            name: 'heart',
            unicode: 'f004'
        },
        {
            name: 'heart-broken',
            unicode: 'f7a9'
        },
        {
            name: 'heartbeat',
            unicode: 'f21e'
        },
        {
            name: 'helicopter',
            unicode: 'f533'
        },
        {
            name: 'highlighter',
            unicode: 'f591'
        },
        {
            name: 'hiking',
            unicode: 'f6ec'
        },
        {
            name: 'hippo',
            unicode: 'f6ed'
        },
        {
            name: 'history',
            unicode: 'f1da'
        },
        {
            name: 'hockey-puck',
            unicode: 'f453'
        },
        {
            name: 'holly-berry',
            unicode: 'f7aa'
        },
        {
            name: 'home',
            unicode: 'f015'
        },
        {
            name: 'horse',
            unicode: 'f6f0'
        },
        {
            name: 'horse-head',
            unicode: 'f7ab'
        },
        {
            name: 'hospital',
            unicode: 'f0f8'
        },
        {
            name: 'hospital-alt',
            unicode: 'f47d'
        },
        {
            name: 'hospital-symbol',
            unicode: 'f47e'
        },
        {
            name: 'hospital-user',
            unicode: 'f80d'
        },
        {
            name: 'hot-tub',
            unicode: 'f593'
        },
        {
            name: 'hotdog',
            unicode: 'f80f'
        },
        {
            name: 'hotel',
            unicode: 'f594'
        },
        {
            name: 'hourglass',
            unicode: 'f254'
        },
        {
            name: 'hourglass-end',
            unicode: 'f253'
        },
        {
            name: 'hourglass-half',
            unicode: 'f252'
        },
        {
            name: 'hourglass-start',
            unicode: 'f251'
        },
        {
            name: 'house-damage',
            unicode: 'f6f1'
        },
        {
            name: 'house-user',
            unicode: 'e065'
        },
        {
            name: 'hryvnia',
            unicode: 'f6f2'
        },
        {
            name: 'i-cursor',
            unicode: 'f246'
        },
        {
            name: 'ice-cream',
            unicode: 'f810'
        },
        {
            name: 'icicles',
            unicode: 'f7ad'
        },
        {
            name: 'icons',
            unicode: 'f86d'
        },
        {
            name: 'id-badge',
            unicode: 'f2c1'
        },
        {
            name: 'id-card',
            unicode: 'f2c2'
        },
        {
            name: 'id-card-alt',
            unicode: 'f47f'
        },
        {
            name: 'igloo',
            unicode: 'f7ae'
        },
        {
            name: 'image',
            unicode: 'f03e'
        },
        {
            name: 'images',
            unicode: 'f302'
        },
        {
            name: 'inbox',
            unicode: 'f01c'
        },
        {
            name: 'indent',
            unicode: 'f03c'
        },
        {
            name: 'industry',
            unicode: 'f275'
        },
        {
            name: 'infinity',
            unicode: 'f534'
        },
        {
            name: 'info',
            unicode: 'f129'
        },
        {
            name: 'info-circle',
            unicode: 'f05a'
        },
        {
            name: 'italic',
            unicode: 'f033'
        },
        {
            name: 'jedi',
            unicode: 'f669'
        },
        {
            name: 'joint',
            unicode: 'f595'
        },
        {
            name: 'journal-whills',
            unicode: 'f66a'
        },
        {
            name: 'kaaba',
            unicode: 'f66b'
        },
        {
            name: 'key',
            unicode: 'f084'
        },
        {
            name: 'keyboard',
            unicode: 'f11c'
        },
        {
            name: 'khanda',
            unicode: 'f66d'
        },
        {
            name: 'kiss',
            unicode: 'f596'
        },
        {
            name: 'kiss-beam',
            unicode: 'f597'
        },
        {
            name: 'kiss-wink-heart',
            unicode: 'f598'
        },
        {
            name: 'kiwi-bird',
            unicode: 'f535'
        },
        {
            name: 'landmark',
            unicode: 'f66f'
        },
        {
            name: 'language',
            unicode: 'f1ab'
        },
        {
            name: 'laptop',
            unicode: 'f109'
        },
        {
            name: 'laptop-code',
            unicode: 'f5fc'
        },
        {
            name: 'laptop-house',
            unicode: 'e066'
        },
        {
            name: 'laptop-medical',
            unicode: 'f812'
        },
        {
            name: 'laugh',
            unicode: 'f599'
        },
        {
            name: 'laugh-beam',
            unicode: 'f59a'
        },
        {
            name: 'laugh-squint',
            unicode: 'f59b'
        },
        {
            name: 'laugh-wink',
            unicode: 'f59c'
        },
        {
            name: 'layer-group',
            unicode: 'f5fd'
        },
        {
            name: 'leaf',
            unicode: 'f06c'
        },
        {
            name: 'lemon',
            unicode: 'f094'
        },
        {
            name: 'less-than',
            unicode: 'f536'
        },
        {
            name: 'less-than-equal',
            unicode: 'f537'
        },
        {
            name: 'level-down-alt',
            unicode: 'f3be'
        },
        {
            name: 'level-up-alt',
            unicode: 'f3bf'
        },
        {
            name: 'life-ring',
            unicode: 'f1cd'
        },
        {
            name: 'lightbulb',
            unicode: 'f0eb'
        },
        {
            name: 'link',
            unicode: 'f0c1'
        },
        {
            name: 'lira-sign',
            unicode: 'f195'
        },
        {
            name: 'list',
            unicode: 'f03a'
        },
        {
            name: 'list-alt',
            unicode: 'f022'
        },
        {
            name: 'list-ol',
            unicode: 'f0cb'
        },
        {
            name: 'list-ul',
            unicode: 'f0ca'
        },
        {
            name: 'location-arrow',
            unicode: 'f124'
        },
        {
            name: 'lock',
            unicode: 'f023'
        },
        {
            name: 'lock-open',
            unicode: 'f3c1'
        },
        {
            name: 'long-arrow-alt-down',
            unicode: 'f309'
        },
        {
            name: 'long-arrow-alt-left',
            unicode: 'f30a'
        },
        {
            name: 'long-arrow-alt-right',
            unicode: 'f30b'
        },
        {
            name: 'long-arrow-alt-up',
            unicode: 'f30c'
        },
        {
            name: 'low-vision',
            unicode: 'f2a8'
        },
        {
            name: 'luggage-cart',
            unicode: 'f59d'
        },
        {
            name: 'lungs',
            unicode: 'f604'
        },
        {
            name: 'lungs-virus',
            unicode: 'e067'
        },
        {
            name: 'magic',
            unicode: 'f0d0'
        },
        {
            name: 'magnet',
            unicode: 'f076'
        },
        {
            name: 'mail-bulk',
            unicode: 'f674'
        },
        {
            name: 'male',
            unicode: 'f183'
        },
        {
            name: 'map',
            unicode: 'f279'
        },
        {
            name: 'map-marked',
            unicode: 'f59f'
        },
        {
            name: 'map-marked-alt',
            unicode: 'f5a0'
        },
        {
            name: 'map-marker',
            unicode: 'f041'
        },
        {
            name: 'map-marker-alt',
            unicode: 'f3c5'
        },
        {
            name: 'map-pin',
            unicode: 'f276'
        },
        {
            name: 'map-signs',
            unicode: 'f277'
        },
        {
            name: 'marker',
            unicode: 'f5a1'
        },
        {
            name: 'mars',
            unicode: 'f222'
        },
        {
            name: 'mars-double',
            unicode: 'f227'
        },
        {
            name: 'mars-stroke',
            unicode: 'f229'
        },
        {
            name: 'mars-stroke-h',
            unicode: 'f22b'
        },
        {
            name: 'mars-stroke-v',
            unicode: 'f22a'
        },
        {
            name: 'mask',
            unicode: 'f6fa'
        },
        {
            name: 'medal',
            unicode: 'f5a2'
        },
        {
            name: 'medkit',
            unicode: 'f0fa'
        },
        {
            name: 'meh',
            unicode: 'f11a'
        },
        {
            name: 'meh-blank',
            unicode: 'f5a4'
        },
        {
            name: 'meh-rolling-eyes',
            unicode: 'f5a5'
        },
        {
            name: 'memory',
            unicode: 'f538'
        },
        {
            name: 'menorah',
            unicode: 'f676'
        },
        {
            name: 'mercury',
            unicode: 'f223'
        },
        {
            name: 'meteor',
            unicode: 'f753'
        },
        {
            name: 'microchip',
            unicode: 'f2db'
        },
        {
            name: 'microphone',
            unicode: 'f130'
        },
        {
            name: 'microphone-alt',
            unicode: 'f3c9'
        },
        {
            name: 'microphone-alt-slash',
            unicode: 'f539'
        },
        {
            name: 'microphone-slash',
            unicode: 'f131'
        },
        {
            name: 'microscope',
            unicode: 'f610'
        },
        {
            name: 'minus',
            unicode: 'f068'
        },
        {
            name: 'minus-circle',
            unicode: 'f056'
        },
        {
            name: 'minus-square',
            unicode: 'f146'
        },
        {
            name: 'mitten',
            unicode: 'f7b5'
        },
        {
            name: 'mobile',
            unicode: 'f10b'
        },
        {
            name: 'mobile-alt',
            unicode: 'f3cd'
        },
        {
            name: 'money-bill',
            unicode: 'f0d6'
        },
        {
            name: 'money-bill-alt',
            unicode: 'f3d1'
        },
        {
            name: 'money-bill-wave',
            unicode: 'f53a'
        },
        {
            name: 'money-bill-wave-alt',
            unicode: 'f53b'
        },
        {
            name: 'money-check',
            unicode: 'f53c'
        },
        {
            name: 'money-check-alt',
            unicode: 'f53d'
        },
        {
            name: 'monument',
            unicode: 'f5a6'
        },
        {
            name: 'moon',
            unicode: 'f186'
        },
        {
            name: 'mortar-pestle',
            unicode: 'f5a7'
        },
        {
            name: 'mosque',
            unicode: 'f678'
        },
        {
            name: 'motorcycle',
            unicode: 'f21c'
        },
        {
            name: 'mountain',
            unicode: 'f6fc'
        },
        {
            name: 'mouse',
            unicode: 'f8cc'
        },
        {
            name: 'mouse-pointer',
            unicode: 'f245'
        },
        {
            name: 'mug-hot',
            unicode: 'f7b6'
        },
        {
            name: 'music',
            unicode: 'f001'
        },
        {
            name: 'network-wired',
            unicode: 'f6ff'
        },
        {
            name: 'neuter',
            unicode: 'f22c'
        },
        {
            name: 'newspaper',
            unicode: 'f1ea'
        },
        {
            name: 'not-equal',
            unicode: 'f53e'
        },
        {
            name: 'notes-medical',
            unicode: 'f481'
        },
        {
            name: 'object-group',
            unicode: 'f247'
        },
        {
            name: 'object-ungroup',
            unicode: 'f248'
        },
        {
            name: 'oil-can',
            unicode: 'f613'
        },
        {
            name: 'om',
            unicode: 'f679'
        },
        {
            name: 'otter',
            unicode: 'f700'
        },
        {
            name: 'outdent',
            unicode: 'f03b'
        },
        {
            name: 'pager',
            unicode: 'f815'
        },
        {
            name: 'paint-brush',
            unicode: 'f1fc'
        },
        {
            name: 'paint-roller',
            unicode: 'f5aa'
        },
        {
            name: 'palette',
            unicode: 'f53f'
        },
        {
            name: 'pallet',
            unicode: 'f482'
        },
        {
            name: 'paper-plane',
            unicode: 'f1d8'
        },
        {
            name: 'paperclip',
            unicode: 'f0c6'
        },
        {
            name: 'parachute-box',
            unicode: 'f4cd'
        },
        {
            name: 'paragraph',
            unicode: 'f1dd'
        },
        {
            name: 'parking',
            unicode: 'f540'
        },
        {
            name: 'passport',
            unicode: 'f5ab'
        },
        {
            name: 'pastafarianism',
            unicode: 'f67b'
        },
        {
            name: 'paste',
            unicode: 'f0ea'
        },
        {
            name: 'pause',
            unicode: 'f04c'
        },
        {
            name: 'pause-circle',
            unicode: 'f28b'
        },
        {
            name: 'paw',
            unicode: 'f1b0'
        },
        {
            name: 'peace',
            unicode: 'f67c'
        },
        {
            name: 'pen',
            unicode: 'f304'
        },
        {
            name: 'pen-alt',
            unicode: 'f305'
        },
        {
            name: 'pen-fancy',
            unicode: 'f5ac'
        },
        {
            name: 'pen-nib',
            unicode: 'f5ad'
        },
        {
            name: 'pen-square',
            unicode: 'f14b'
        },
        {
            name: 'pencil-alt',
            unicode: 'f303'
        },
        {
            name: 'pencil-ruler',
            unicode: 'f5ae'
        },
        {
            name: 'people-arrows',
            unicode: 'e068'
        },
        {
            name: 'people-carry',
            unicode: 'f4ce'
        },
        {
            name: 'pepper-hot',
            unicode: 'f816'
        },
        {
            name: 'percent',
            unicode: 'f295'
        },
        {
            name: 'percentage',
            unicode: 'f541'
        },
        {
            name: 'person-booth',
            unicode: 'f756'
        },
        {
            name: 'phone',
            unicode: 'f095'
        },
        {
            name: 'phone-alt',
            unicode: 'f879'
        },
        {
            name: 'phone-slash',
            unicode: 'f3dd'
        },
        {
            name: 'phone-square',
            unicode: 'f098'
        },
        {
            name: 'phone-square-alt',
            unicode: 'f87b'
        },
        {
            name: 'phone-volume',
            unicode: 'f2a0'
        },
        {
            name: 'photo-video',
            unicode: 'f87c'
        },
        {
            name: 'piggy-bank',
            unicode: 'f4d3'
        },
        {
            name: 'pills',
            unicode: 'f484'
        },
        {
            name: 'pizza-slice',
            unicode: 'f818'
        },
        {
            name: 'place-of-worship',
            unicode: 'f67f'
        },
        {
            name: 'plane',
            unicode: 'f072'
        },
        {
            name: 'plane-arrival',
            unicode: 'f5af'
        },
        {
            name: 'plane-departure',
            unicode: 'f5b0'
        },
        {
            name: 'plane-slash',
            unicode: 'e069'
        },
        {
            name: 'play',
            unicode: 'f04b'
        },
        {
            name: 'play-circle',
            unicode: 'f144'
        },
        {
            name: 'plug',
            unicode: 'f1e6'
        },
        {
            name: 'plus',
            unicode: 'f067'
        },
        {
            name: 'plus-circle',
            unicode: 'f055'
        },
        {
            name: 'plus-square',
            unicode: 'f0fe'
        },
        {
            name: 'podcast',
            unicode: 'f2ce'
        },
        {
            name: 'poll',
            unicode: 'f681'
        },
        {
            name: 'poll-h',
            unicode: 'f682'
        },
        {
            name: 'poo',
            unicode: 'f2fe'
        },
        {
            name: 'poo-storm',
            unicode: 'f75a'
        },
        {
            name: 'poop',
            unicode: 'f619'
        },
        {
            name: 'portrait',
            unicode: 'f3e0'
        },
        {
            name: 'pound-sign',
            unicode: 'f154'
        },
        {
            name: 'power-off',
            unicode: 'f011'
        },
        {
            name: 'pray',
            unicode: 'f683'
        },
        {
            name: 'praying-hands',
            unicode: 'f684'
        },
        {
            name: 'prescription',
            unicode: 'f5b1'
        },
        {
            name: 'prescription-bottle',
            unicode: 'f485'
        },
        {
            name: 'prescription-bottle-alt',
            unicode: 'f486'
        },
        {
            name: 'print',
            unicode: 'f02f'
        },
        {
            name: 'procedures',
            unicode: 'f487'
        },
        {
            name: 'project-diagram',
            unicode: 'f542'
        },
        {
            name: 'pump-medical',
            unicode: 'e06a'
        },
        {
            name: 'pump-soap',
            unicode: 'e06b'
        },
        {
            name: 'puzzle-piece',
            unicode: 'f12e'
        },
        {
            name: 'qrcode',
            unicode: 'f029'
        },
        {
            name: 'question',
            unicode: 'f128'
        },
        {
            name: 'question-circle',
            unicode: 'f059'
        },
        {
            name: 'quidditch',
            unicode: 'f458'
        },
        {
            name: 'quote-left',
            unicode: 'f10d'
        },
        {
            name: 'quote-right',
            unicode: 'f10e'
        },
        {
            name: 'quran',
            unicode: 'f687'
        },
        {
            name: 'radiation',
            unicode: 'f7b9'
        },
        {
            name: 'radiation-alt',
            unicode: 'f7ba'
        },
        {
            name: 'rainbow',
            unicode: 'f75b'
        },
        {
            name: 'random',
            unicode: 'f074'
        },
        {
            name: 'receipt',
            unicode: 'f543'
        },
        {
            name: 'record-vinyl',
            unicode: 'f8d9'
        },
        {
            name: 'recycle',
            unicode: 'f1b8'
        },
        {
            name: 'redo',
            unicode: 'f01e'
        },
        {
            name: 'redo-alt',
            unicode: 'f2f9'
        },
        {
            name: 'registered',
            unicode: 'f25d'
        },
        {
            name: 'remove-format',
            unicode: 'f87d'
        },
        {
            name: 'reply',
            unicode: 'f3e5'
        },
        {
            name: 'reply-all',
            unicode: 'f122'
        },
        {
            name: 'republican',
            unicode: 'f75e'
        },
        {
            name: 'restroom',
            unicode: 'f7bd'
        },
        {
            name: 'retweet',
            unicode: 'f079'
        },
        {
            name: 'ribbon',
            unicode: 'f4d6'
        },
        {
            name: 'ring',
            unicode: 'f70b'
        },
        {
            name: 'road',
            unicode: 'f018'
        },
        {
            name: 'robot',
            unicode: 'f544'
        },
        {
            name: 'rocket',
            unicode: 'f135'
        },
        {
            name: 'route',
            unicode: 'f4d7'
        },
        {
            name: 'rss',
            unicode: 'f09e'
        },
        {
            name: 'rss-square',
            unicode: 'f143'
        },
        {
            name: 'ruble-sign',
            unicode: 'f158'
        },
        {
            name: 'ruler',
            unicode: 'f545'
        },
        {
            name: 'ruler-combined',
            unicode: 'f546'
        },
        {
            name: 'ruler-horizontal',
            unicode: 'f547'
        },
        {
            name: 'ruler-vertical',
            unicode: 'f548'
        },
        {
            name: 'running',
            unicode: 'f70c'
        },
        {
            name: 'rupee-sign',
            unicode: 'f156'
        },
        {
            name: 'sad-cry',
            unicode: 'f5b3'
        },
        {
            name: 'sad-tear',
            unicode: 'f5b4'
        },
        {
            name: 'satellite',
            unicode: 'f7bf'
        },
        {
            name: 'satellite-dish',
            unicode: 'f7c0'
        },
        {
            name: 'save',
            unicode: 'f0c7'
        },
        {
            name: 'school',
            unicode: 'f549'
        },
        {
            name: 'screwdriver',
            unicode: 'f54a'
        },
        {
            name: 'scroll',
            unicode: 'f70e'
        },
        {
            name: 'sd-card',
            unicode: 'f7c2'
        },
        {
            name: 'search',
            unicode: 'f002'
        },
        {
            name: 'search-dollar',
            unicode: 'f688'
        },
        {
            name: 'search-location',
            unicode: 'f689'
        },
        {
            name: 'search-minus',
            unicode: 'f010'
        },
        {
            name: 'search-plus',
            unicode: 'f00e'
        },
        {
            name: 'seedling',
            unicode: 'f4d8'
        },
        {
            name: 'server',
            unicode: 'f233'
        },
        {
            name: 'shapes',
            unicode: 'f61f'
        },
        {
            name: 'share',
            unicode: 'f064'
        },
        {
            name: 'share-alt',
            unicode: 'f1e0'
        },
        {
            name: 'share-alt-square',
            unicode: 'f1e1'
        },
        {
            name: 'share-square',
            unicode: 'f14d'
        },
        {
            name: 'shekel-sign',
            unicode: 'f20b'
        },
        {
            name: 'shield-alt',
            unicode: 'f3ed'
        },
        {
            name: 'shield-virus',
            unicode: 'e06c'
        },
        {
            name: 'ship',
            unicode: 'f21a'
        },
        {
            name: 'shipping-fast',
            unicode: 'f48b'
        },
        {
            name: 'shoe-prints',
            unicode: 'f54b'
        },
        {
            name: 'shopping-bag',
            unicode: 'f290'
        },
        {
            name: 'shopping-basket',
            unicode: 'f291'
        },
        {
            name: 'shopping-cart',
            unicode: 'f07a'
        },
        {
            name: 'shower',
            unicode: 'f2cc'
        },
        {
            name: 'shuttle-van',
            unicode: 'f5b6'
        },
        {
            name: 'sign',
            unicode: 'f4d9'
        },
        {
            name: 'sign-in-alt',
            unicode: 'f2f6'
        },
        {
            name: 'sign-language',
            unicode: 'f2a7'
        },
        {
            name: 'sign-out-alt',
            unicode: 'f2f5'
        },
        {
            name: 'signal',
            unicode: 'f012'
        },
        {
            name: 'signature',
            unicode: 'f5b7'
        },
        {
            name: 'sim-card',
            unicode: 'f7c4'
        },
        {
            name: 'sink',
            unicode: 'e06d'
        },
        {
            name: 'sitemap',
            unicode: 'f0e8'
        },
        {
            name: 'skating',
            unicode: 'f7c5'
        },
        {
            name: 'skiing',
            unicode: 'f7c9'
        },
        {
            name: 'skiing-nordic',
            unicode: 'f7ca'
        },
        {
            name: 'skull',
            unicode: 'f54c'
        },
        {
            name: 'skull-crossbones',
            unicode: 'f714'
        },
        {
            name: 'slash',
            unicode: 'f715'
        },
        {
            name: 'sleigh',
            unicode: 'f7cc'
        },
        {
            name: 'sliders-h',
            unicode: 'f1de'
        },
        {
            name: 'smile',
            unicode: 'f118'
        },
        {
            name: 'smile-beam',
            unicode: 'f5b8'
        },
        {
            name: 'smile-wink',
            unicode: 'f4da'
        },
        {
            name: 'smog',
            unicode: 'f75f'
        },
        {
            name: 'smoking',
            unicode: 'f48d'
        },
        {
            name: 'smoking-ban',
            unicode: 'f54d'
        },
        {
            name: 'sms',
            unicode: 'f7cd'
        },
        {
            name: 'snowboarding',
            unicode: 'f7ce'
        },
        {
            name: 'snowflake',
            unicode: 'f2dc'
        },
        {
            name: 'snowman',
            unicode: 'f7d0'
        },
        {
            name: 'snowplow',
            unicode: 'f7d2'
        },
        {
            name: 'soap',
            unicode: 'e06e'
        },
        {
            name: 'socks',
            unicode: 'f696'
        },
        {
            name: 'solar-panel',
            unicode: 'f5ba'
        },
        {
            name: 'sort',
            unicode: 'f0dc'
        },
        {
            name: 'sort-alpha-down',
            unicode: 'f15d'
        },
        {
            name: 'sort-alpha-down-alt',
            unicode: 'f881'
        },
        {
            name: 'sort-alpha-up',
            unicode: 'f15e'
        },
        {
            name: 'sort-alpha-up-alt',
            unicode: 'f882'
        },
        {
            name: 'sort-amount-down',
            unicode: 'f160'
        },
        {
            name: 'sort-amount-down-alt',
            unicode: 'f884'
        },
        {
            name: 'sort-amount-up',
            unicode: 'f161'
        },
        {
            name: 'sort-amount-up-alt',
            unicode: 'f885'
        },
        {
            name: 'sort-down',
            unicode: 'f0dd'
        },
        {
            name: 'sort-numeric-down',
            unicode: 'f162'
        },
        {
            name: 'sort-numeric-down-alt',
            unicode: 'f886'
        },
        {
            name: 'sort-numeric-up',
            unicode: 'f163'
        },
        {
            name: 'sort-numeric-up-alt',
            unicode: 'f887'
        },
        {
            name: 'sort-up',
            unicode: 'f0de'
        },
        {
            name: 'spa',
            unicode: 'f5bb'
        },
        {
            name: 'space-shuttle',
            unicode: 'f197'
        },
        {
            name: 'spell-check',
            unicode: 'f891'
        },
        {
            name: 'spider',
            unicode: 'f717'
        },
        {
            name: 'spinner',
            unicode: 'f110'
        },
        {
            name: 'splotch',
            unicode: 'f5bc'
        },
        {
            name: 'spray-can',
            unicode: 'f5bd'
        },
        {
            name: 'square',
            unicode: 'f0c8'
        },
        {
            name: 'square-full',
            unicode: 'f45c'
        },
        {
            name: 'square-root-alt',
            unicode: 'f698'
        },
        {
            name: 'stamp',
            unicode: 'f5bf'
        },
        {
            name: 'star',
            unicode: 'f005'
        },
        {
            name: 'star-and-crescent',
            unicode: 'f699'
        },
        {
            name: 'star-half',
            unicode: 'f089'
        },
        {
            name: 'star-half-alt',
            unicode: 'f5c0'
        },
        {
            name: 'star-of-david',
            unicode: 'f69a'
        },
        {
            name: 'star-of-life',
            unicode: 'f621'
        },
        {
            name: 'step-backward',
            unicode: 'f048'
        },
        {
            name: 'step-forward',
            unicode: 'f051'
        },
        {
            name: 'stethoscope',
            unicode: 'f0f1'
        },
        {
            name: 'sticky-note',
            unicode: 'f249'
        },
        {
            name: 'stop',
            unicode: 'f04d'
        },
        {
            name: 'stop-circle',
            unicode: 'f28d'
        },
        {
            name: 'stopwatch',
            unicode: 'f2f2'
        },
        {
            name: 'stopwatch-20',
            unicode: 'e06f'
        },
        {
            name: 'store',
            unicode: 'f54e'
        },
        {
            name: 'store-alt',
            unicode: 'f54f'
        },
        {
            name: 'store-alt-slash',
            unicode: 'e070'
        },
        {
            name: 'store-slash',
            unicode: 'e071'
        },
        {
            name: 'stream',
            unicode: 'f550'
        },
        {
            name: 'street-view',
            unicode: 'f21d'
        },
        {
            name: 'strikethrough',
            unicode: 'f0cc'
        },
        {
            name: 'stroopwafel',
            unicode: 'f551'
        },
        {
            name: 'subscript',
            unicode: 'f12c'
        },
        {
            name: 'subway',
            unicode: 'f239'
        },
        {
            name: 'suitcase',
            unicode: 'f0f2'
        },
        {
            name: 'suitcase-rolling',
            unicode: 'f5c1'
        },
        {
            name: 'sun',
            unicode: 'f185'
        },
        {
            name: 'superscript',
            unicode: 'f12b'
        },
        {
            name: 'surprise',
            unicode: 'f5c2'
        },
        {
            name: 'swatchbook',
            unicode: 'f5c3'
        },
        {
            name: 'swimmer',
            unicode: 'f5c4'
        },
        {
            name: 'swimming-pool',
            unicode: 'f5c5'
        },
        {
            name: 'synagogue',
            unicode: 'f69b'
        },
        {
            name: 'sync',
            unicode: 'f021'
        },
        {
            name: 'sync-alt',
            unicode: 'f2f1'
        },
        {
            name: 'syringe',
            unicode: 'f48e'
        },
        {
            name: 'table',
            unicode: 'f0ce'
        },
        {
            name: 'table-tennis',
            unicode: 'f45d'
        },
        {
            name: 'tablet',
            unicode: 'f10a'
        },
        {
            name: 'tablet-alt',
            unicode: 'f3fa'
        },
        {
            name: 'tablets',
            unicode: 'f490'
        },
        {
            name: 'tachometer-alt',
            unicode: 'f3fd'
        },
        {
            name: 'tag',
            unicode: 'f02b'
        },
        {
            name: 'tags',
            unicode: 'f02c'
        },
        {
            name: 'tape',
            unicode: 'f4db'
        },
        {
            name: 'tasks',
            unicode: 'f0ae'
        },
        {
            name: 'taxi',
            unicode: 'f1ba'
        },
        {
            name: 'teeth',
            unicode: 'f62e'
        },
        {
            name: 'teeth-open',
            unicode: 'f62f'
        },
        {
            name: 'temperature-high',
            unicode: 'f769'
        },
        {
            name: 'temperature-low',
            unicode: 'f76b'
        },
        {
            name: 'tenge',
            unicode: 'f7d7'
        },
        {
            name: 'terminal',
            unicode: 'f120'
        },
        {
            name: 'text-height',
            unicode: 'f034'
        },
        {
            name: 'text-width',
            unicode: 'f035'
        },
        {
            name: 'th',
            unicode: 'f00a'
        },
        {
            name: 'th-large',
            unicode: 'f009'
        },
        {
            name: 'th-list',
            unicode: 'f00b'
        },
        {
            name: 'theater-masks',
            unicode: 'f630'
        },
        {
            name: 'thermometer',
            unicode: 'f491'
        },
        {
            name: 'thermometer-empty',
            unicode: 'f2cb'
        },
        {
            name: 'thermometer-full',
            unicode: 'f2c7'
        },
        {
            name: 'thermometer-half',
            unicode: 'f2c9'
        },
        {
            name: 'thermometer-quarter',
            unicode: 'f2ca'
        },
        {
            name: 'thermometer-three-quarters',
            unicode: 'f2c8'
        },
        {
            name: 'thumbs-down',
            unicode: 'f165'
        },
        {
            name: 'thumbs-up',
            unicode: 'f164'
        },
        {
            name: 'thumbtack',
            unicode: 'f08d'
        },
        {
            name: 'ticket-alt',
            unicode: 'f3ff'
        },
        {
            name: 'times',
            unicode: 'f00d'
        },
        {
            name: 'times-circle',
            unicode: 'f057'
        },
        {
            name: 'tint',
            unicode: 'f043'
        },
        {
            name: 'tint-slash',
            unicode: 'f5c7'
        },
        {
            name: 'tired',
            unicode: 'f5c8'
        },
        {
            name: 'toggle-off',
            unicode: 'f204'
        },
        {
            name: 'toggle-on',
            unicode: 'f205'
        },
        {
            name: 'toilet',
            unicode: 'f7d8'
        },
        {
            name: 'toilet-paper',
            unicode: 'f71e'
        },
        {
            name: 'toilet-paper-slash',
            unicode: 'e072'
        },
        {
            name: 'toolbox',
            unicode: 'f552'
        },
        {
            name: 'tools',
            unicode: 'f7d9'
        },
        {
            name: 'tooth',
            unicode: 'f5c9'
        },
        {
            name: 'torah',
            unicode: 'f6a0'
        },
        {
            name: 'torii-gate',
            unicode: 'f6a1'
        },
        {
            name: 'tractor',
            unicode: 'f722'
        },
        {
            name: 'trademark',
            unicode: 'f25c'
        },
        {
            name: 'traffic-light',
            unicode: 'f637'
        },
        {
            name: 'trailer',
            unicode: 'e041'
        },
        {
            name: 'train',
            unicode: 'f238'
        },
        {
            name: 'tram',
            unicode: 'f7da'
        },
        {
            name: 'transgender',
            unicode: 'f224'
        },
        {
            name: 'transgender-alt',
            unicode: 'f225'
        },
        {
            name: 'trash',
            unicode: 'f1f8'
        },
        {
            name: 'trash-alt',
            unicode: 'f2ed'
        },
        {
            name: 'trash-restore',
            unicode: 'f829'
        },
        {
            name: 'trash-restore-alt',
            unicode: 'f82a'
        },
        {
            name: 'tree',
            unicode: 'f1bb'
        },
        {
            name: 'trophy',
            unicode: 'f091'
        },
        {
            name: 'truck',
            unicode: 'f0d1'
        },
        {
            name: 'truck-loading',
            unicode: 'f4de'
        },
        {
            name: 'truck-monster',
            unicode: 'f63b'
        },
        {
            name: 'truck-moving',
            unicode: 'f4df'
        },
        {
            name: 'truck-pickup',
            unicode: 'f63c'
        },
        {
            name: 'tshirt',
            unicode: 'f553'
        },
        {
            name: 'tty',
            unicode: 'f1e4'
        },
        {
            name: 'tv',
            unicode: 'f26c'
        },
        {
            name: 'umbrella',
            unicode: 'f0e9'
        },
        {
            name: 'umbrella-beach',
            unicode: 'f5ca'
        },
        {
            name: 'underline',
            unicode: 'f0cd'
        },
        {
            name: 'undo',
            unicode: 'f0e2'
        },
        {
            name: 'undo-alt',
            unicode: 'f2ea'
        },
        {
            name: 'universal-access',
            unicode: 'f29a'
        },
        {
            name: 'university',
            unicode: 'f19c'
        },
        {
            name: 'unlink',
            unicode: 'f127'
        },
        {
            name: 'unlock',
            unicode: 'f09c'
        },
        {
            name: 'unlock-alt',
            unicode: 'f13e'
        },
        {
            name: 'upload',
            unicode: 'f093'
        },
        {
            name: 'user',
            unicode: 'f007'
        },
        {
            name: 'user-alt',
            unicode: 'f406'
        },
        {
            name: 'user-alt-slash',
            unicode: 'f4fa'
        },
        {
            name: 'user-astronaut',
            unicode: 'f4fb'
        },
        {
            name: 'user-check',
            unicode: 'f4fc'
        },
        {
            name: 'user-circle',
            unicode: 'f2bd'
        },
        {
            name: 'user-clock',
            unicode: 'f4fd'
        },
        {
            name: 'user-cog',
            unicode: 'f4fe'
        },
        {
            name: 'user-edit',
            unicode: 'f4ff'
        },
        {
            name: 'user-friends',
            unicode: 'f500'
        },
        {
            name: 'user-graduate',
            unicode: 'f501'
        },
        {
            name: 'user-injured',
            unicode: 'f728'
        },
        {
            name: 'user-lock',
            unicode: 'f502'
        },
        {
            name: 'user-md',
            unicode: 'f0f0'
        },
        {
            name: 'user-minus',
            unicode: 'f503'
        },
        {
            name: 'user-ninja',
            unicode: 'f504'
        },
        {
            name: 'user-nurse',
            unicode: 'f82f'
        },
        {
            name: 'user-plus',
            unicode: 'f234'
        },
        {
            name: 'user-secret',
            unicode: 'f21b'
        },
        {
            name: 'user-shield',
            unicode: 'f505'
        },
        {
            name: 'user-slash',
            unicode: 'f506'
        },
        {
            name: 'user-tag',
            unicode: 'f507'
        },
        {
            name: 'user-tie',
            unicode: 'f508'
        },
        {
            name: 'user-times',
            unicode: 'f235'
        },
        {
            name: 'users',
            unicode: 'f0c0'
        },
        {
            name: 'users-cog',
            unicode: 'f509'
        },
        {
            name: 'users-slash',
            unicode: 'e073'
        },
        {
            name: 'utensil-spoon',
            unicode: 'f2e5'
        },
        {
            name: 'utensils',
            unicode: 'f2e7'
        },
        {
            name: 'vector-square',
            unicode: 'f5cb'
        },
        {
            name: 'venus',
            unicode: 'f221'
        },
        {
            name: 'venus-double',
            unicode: 'f226'
        },
        {
            name: 'venus-mars',
            unicode: 'f228'
        },
        {
            name: 'vial',
            unicode: 'f492'
        },
        {
            name: 'vials',
            unicode: 'f493'
        },
        {
            name: 'video',
            unicode: 'f03d'
        },
        {
            name: 'video-slash',
            unicode: 'f4e2'
        },
        {
            name: 'vihara',
            unicode: 'f6a7'
        },
        {
            name: 'virus',
            unicode: 'e074'
        },
        {
            name: 'virus-slash',
            unicode: 'e075'
        },
        {
            name: 'viruses',
            unicode: 'e076'
        },
        {
            name: 'voicemail',
            unicode: 'f897'
        },
        {
            name: 'volleyball-ball',
            unicode: 'f45f'
        },
        {
            name: 'volume-down',
            unicode: 'f027'
        },
        {
            name: 'volume-mute',
            unicode: 'f6a9'
        },
        {
            name: 'volume-off',
            unicode: 'f026'
        },
        {
            name: 'volume-up',
            unicode: 'f028'
        },
        {
            name: 'vote-yea',
            unicode: 'f772'
        },
        {
            name: 'vr-cardboard',
            unicode: 'f729'
        },
        {
            name: 'walking',
            unicode: 'f554'
        },
        {
            name: 'wallet',
            unicode: 'f555'
        },
        {
            name: 'warehouse',
            unicode: 'f494'
        },
        {
            name: 'water',
            unicode: 'f773'
        },
        {
            name: 'wave-square',
            unicode: 'f83e'
        },
        {
            name: 'weight',
            unicode: 'f496'
        },
        {
            name: 'weight-hanging',
            unicode: 'f5cd'
        },
        {
            name: 'wheelchair',
            unicode: 'f193'
        },
        {
            name: 'wifi',
            unicode: 'f1eb'
        },
        {
            name: 'wind',
            unicode: 'f72e'
        },
        {
            name: 'window-close',
            unicode: 'f410'
        },
        {
            name: 'window-maximize',
            unicode: 'f2d0'
        },
        {
            name: 'window-minimize',
            unicode: 'f2d1'
        },
        {
            name: 'window-restore',
            unicode: 'f2d2'
        },
        {
            name: 'wine-bottle',
            unicode: 'f72f'
        },
        {
            name: 'wine-glass',
            unicode: 'f4e3'
        },
        {
            name: 'wine-glass-alt',
            unicode: 'f5ce'
        },
        {
            name: 'won-sign',
            unicode: 'f159'
        },
        {
            name: 'wrench',
            unicode: 'f0ad'
        },
        {
            name: 'x-ray',
            unicode: 'f497'
        },
        {
            name: 'yen-sign',
            unicode: 'f157'
        },
        {
            name: 'yin-yang',
            unicode: 'f6ad'
        }
    ],
    regular: [
        {
            name: 'address-book',
            unicode: 'f2b9'
        },
        {
            name: 'address-card',
            unicode: 'f2bb'
        },
        {
            name: 'angry',
            unicode: 'f556'
        },
        {
            name: 'arrow-alt-circle-down',
            unicode: 'f358'
        },
        {
            name: 'arrow-alt-circle-left',
            unicode: 'f359'
        },
        {
            name: 'arrow-alt-circle-right',
            unicode: 'f35a'
        },
        {
            name: 'arrow-alt-circle-up',
            unicode: 'f35b'
        },
        {
            name: 'bell',
            unicode: 'f0f3'
        },
        {
            name: 'bell-slash',
            unicode: 'f1f6'
        },
        {
            name: 'bookmark',
            unicode: 'f02e'
        },
        {
            name: 'building',
            unicode: 'f1ad'
        },
        {
            name: 'calendar',
            unicode: 'f133'
        },
        {
            name: 'calendar-alt',
            unicode: 'f073'
        },
        {
            name: 'calendar-check',
            unicode: 'f274'
        },
        {
            name: 'calendar-minus',
            unicode: 'f272'
        },
        {
            name: 'calendar-plus',
            unicode: 'f271'
        },
        {
            name: 'calendar-times',
            unicode: 'f273'
        },
        {
            name: 'caret-square-down',
            unicode: 'f150'
        },
        {
            name: 'caret-square-left',
            unicode: 'f191'
        },
        {
            name: 'caret-square-right',
            unicode: 'f152'
        },
        {
            name: 'caret-square-up',
            unicode: 'f151'
        },
        {
            name: 'chart-bar',
            unicode: 'f080'
        },
        {
            name: 'check-circle',
            unicode: 'f058'
        },
        {
            name: 'check-square',
            unicode: 'f14a'
        },
        {
            name: 'circle',
            unicode: 'f111'
        },
        {
            name: 'clipboard',
            unicode: 'f328'
        },
        {
            name: 'clock',
            unicode: 'f017'
        },
        {
            name: 'clone',
            unicode: 'f24d'
        },
        {
            name: 'closed-captioning',
            unicode: 'f20a'
        },
        {
            name: 'comment',
            unicode: 'f075'
        },
        {
            name: 'comment-alt',
            unicode: 'f27a'
        },
        {
            name: 'comment-dots',
            unicode: 'f4ad'
        },
        {
            name: 'comments',
            unicode: 'f086'
        },
        {
            name: 'compass',
            unicode: 'f14e'
        },
        {
            name: 'copy',
            unicode: 'f0c5'
        },
        {
            name: 'copyright',
            unicode: 'f1f9'
        },
        {
            name: 'credit-card',
            unicode: 'f09d'
        },
        {
            name: 'dizzy',
            unicode: 'f567'
        },
        {
            name: 'dot-circle',
            unicode: 'f192'
        },
        {
            name: 'edit',
            unicode: 'f044'
        },
        {
            name: 'envelope',
            unicode: 'f0e0'
        },
        {
            name: 'envelope-open',
            unicode: 'f2b6'
        },
        {
            name: 'eye',
            unicode: 'f06e'
        },
        {
            name: 'eye-slash',
            unicode: 'f070'
        },
        {
            name: 'file',
            unicode: 'f15b'
        },
        {
            name: 'file-alt',
            unicode: 'f15c'
        },
        {
            name: 'file-archive',
            unicode: 'f1c6'
        },
        {
            name: 'file-audio',
            unicode: 'f1c7'
        },
        {
            name: 'file-code',
            unicode: 'f1c9'
        },
        {
            name: 'file-excel',
            unicode: 'f1c3'
        },
        {
            name: 'file-image',
            unicode: 'f1c5'
        },
        {
            name: 'file-pdf',
            unicode: 'f1c1'
        },
        {
            name: 'file-powerpoint',
            unicode: 'f1c4'
        },
        {
            name: 'file-video',
            unicode: 'f1c8'
        },
        {
            name: 'file-word',
            unicode: 'f1c2'
        },
        {
            name: 'flag',
            unicode: 'f024'
        },
        {
            name: 'flushed',
            unicode: 'f579'
        },
        {
            name: 'folder',
            unicode: 'f07b'
        },
        {
            name: 'folder-open',
            unicode: 'f07c'
        },
        {
            name: 'font-awesome-logo-full',
            unicode: 'f4e6'
        },
        {
            name: 'frown',
            unicode: 'f119'
        },
        {
            name: 'frown-open',
            unicode: 'f57a'
        },
        {
            name: 'futbol',
            unicode: 'f1e3'
        },
        {
            name: 'gem',
            unicode: 'f3a5'
        },
        {
            name: 'grimace',
            unicode: 'f57f'
        },
        {
            name: 'grin',
            unicode: 'f580'
        },
        {
            name: 'grin-alt',
            unicode: 'f581'
        },
        {
            name: 'grin-beam',
            unicode: 'f582'
        },
        {
            name: 'grin-beam-sweat',
            unicode: 'f583'
        },
        {
            name: 'grin-hearts',
            unicode: 'f584'
        },
        {
            name: 'grin-squint',
            unicode: 'f585'
        },
        {
            name: 'grin-squint-tears',
            unicode: 'f586'
        },
        {
            name: 'grin-stars',
            unicode: 'f587'
        },
        {
            name: 'grin-tears',
            unicode: 'f588'
        },
        {
            name: 'grin-tongue',
            unicode: 'f589'
        },
        {
            name: 'grin-tongue-squint',
            unicode: 'f58a'
        },
        {
            name: 'grin-tongue-wink',
            unicode: 'f58b'
        },
        {
            name: 'grin-wink',
            unicode: 'f58c'
        },
        {
            name: 'hand-lizard',
            unicode: 'f258'
        },
        {
            name: 'hand-paper',
            unicode: 'f256'
        },
        {
            name: 'hand-peace',
            unicode: 'f25b'
        },
        {
            name: 'hand-point-down',
            unicode: 'f0a7'
        },
        {
            name: 'hand-point-left',
            unicode: 'f0a5'
        },
        {
            name: 'hand-point-right',
            unicode: 'f0a4'
        },
        {
            name: 'hand-point-up',
            unicode: 'f0a6'
        },
        {
            name: 'hand-pointer',
            unicode: 'f25a'
        },
        {
            name: 'hand-rock',
            unicode: 'f255'
        },
        {
            name: 'hand-scissors',
            unicode: 'f257'
        },
        {
            name: 'hand-spock',
            unicode: 'f259'
        },
        {
            name: 'handshake',
            unicode: 'f2b5'
        },
        {
            name: 'hdd',
            unicode: 'f0a0'
        },
        {
            name: 'heart',
            unicode: 'f004'
        },
        {
            name: 'hospital',
            unicode: 'f0f8'
        },
        {
            name: 'hourglass',
            unicode: 'f254'
        },
        {
            name: 'id-badge',
            unicode: 'f2c1'
        },
        {
            name: 'id-card',
            unicode: 'f2c2'
        },
        {
            name: 'image',
            unicode: 'f03e'
        },
        {
            name: 'images',
            unicode: 'f302'
        },
        {
            name: 'keyboard',
            unicode: 'f11c'
        },
        {
            name: 'kiss',
            unicode: 'f596'
        },
        {
            name: 'kiss-beam',
            unicode: 'f597'
        },
        {
            name: 'kiss-wink-heart',
            unicode: 'f598'
        },
        {
            name: 'laugh',
            unicode: 'f599'
        },
        {
            name: 'laugh-beam',
            unicode: 'f59a'
        },
        {
            name: 'laugh-squint',
            unicode: 'f59b'
        },
        {
            name: 'laugh-wink',
            unicode: 'f59c'
        },
        {
            name: 'lemon',
            unicode: 'f094'
        },
        {
            name: 'life-ring',
            unicode: 'f1cd'
        },
        {
            name: 'lightbulb',
            unicode: 'f0eb'
        },
        {
            name: 'list-alt',
            unicode: 'f022'
        },
        {
            name: 'map',
            unicode: 'f279'
        },
        {
            name: 'meh',
            unicode: 'f11a'
        },
        {
            name: 'meh-blank',
            unicode: 'f5a4'
        },
        {
            name: 'meh-rolling-eyes',
            unicode: 'f5a5'
        },
        {
            name: 'minus-square',
            unicode: 'f146'
        },
        {
            name: 'money-bill-alt',
            unicode: 'f3d1'
        },
        {
            name: 'moon',
            unicode: 'f186'
        },
        {
            name: 'newspaper',
            unicode: 'f1ea'
        },
        {
            name: 'object-group',
            unicode: 'f247'
        },
        {
            name: 'object-ungroup',
            unicode: 'f248'
        },
        {
            name: 'paper-plane',
            unicode: 'f1d8'
        },
        {
            name: 'pause-circle',
            unicode: 'f28b'
        },
        {
            name: 'play-circle',
            unicode: 'f144'
        },
        {
            name: 'plus-square',
            unicode: 'f0fe'
        },
        {
            name: 'question-circle',
            unicode: 'f059'
        },
        {
            name: 'registered',
            unicode: 'f25d'
        },
        {
            name: 'sad-cry',
            unicode: 'f5b3'
        },
        {
            name: 'sad-tear',
            unicode: 'f5b4'
        },
        {
            name: 'save',
            unicode: 'f0c7'
        },
        {
            name: 'share-square',
            unicode: 'f14d'
        },
        {
            name: 'smile',
            unicode: 'f118'
        },
        {
            name: 'smile-beam',
            unicode: 'f5b8'
        },
        {
            name: 'smile-wink',
            unicode: 'f4da'
        },
        {
            name: 'snowflake',
            unicode: 'f2dc'
        },
        {
            name: 'square',
            unicode: 'f0c8'
        },
        {
            name: 'star',
            unicode: 'f005'
        },
        {
            name: 'star-half',
            unicode: 'f089'
        },
        {
            name: 'sticky-note',
            unicode: 'f249'
        },
        {
            name: 'stop-circle',
            unicode: 'f28d'
        },
        {
            name: 'sun',
            unicode: 'f185'
        },
        {
            name: 'surprise',
            unicode: 'f5c2'
        },
        {
            name: 'thumbs-down',
            unicode: 'f165'
        },
        {
            name: 'thumbs-up',
            unicode: 'f164'
        },
        {
            name: 'times-circle',
            unicode: 'f057'
        },
        {
            name: 'tired',
            unicode: 'f5c8'
        },
        {
            name: 'trash-alt',
            unicode: 'f2ed'
        },
        {
            name: 'user',
            unicode: 'f007'
        },
        {
            name: 'user-circle',
            unicode: 'f2bd'
        },
        {
            name: 'window-close',
            unicode: 'f410'
        },
        {
            name: 'window-maximize',
            unicode: 'f2d0'
        },
        {
            name: 'window-minimize',
            unicode: 'f2d1'
        },
        {
            name: 'window-restore',
            unicode: 'f2d2'
        }
    ],
    brands: [
        {
            name: '500px',
            unicode: 'f26e'
        },
        {
            name: 'accessible-icon',
            unicode: 'f368'
        },
        {
            name: 'accusoft',
            unicode: 'f369'
        },
        {
            name: 'acquisitions-incorporated',
            unicode: 'f6af'
        },
        {
            name: 'adn',
            unicode: 'f170'
        },
        {
            name: 'adobe',
            unicode: 'f778'
        },
        {
            name: 'adversal',
            unicode: 'f36a'
        },
        {
            name: 'affiliatetheme',
            unicode: 'f36b'
        },
        {
            name: 'airbnb',
            unicode: 'f834'
        },
        {
            name: 'algolia',
            unicode: 'f36c'
        },
        {
            name: 'alipay',
            unicode: 'f642'
        },
        {
            name: 'amazon',
            unicode: 'f270'
        },
        {
            name: 'amazon-pay',
            unicode: 'f42c'
        },
        {
            name: 'amilia',
            unicode: 'f36d'
        },
        {
            name: 'android',
            unicode: 'f17b'
        },
        {
            name: 'angellist',
            unicode: 'f209'
        },
        {
            name: 'angrycreative',
            unicode: 'f36e'
        },
        {
            name: 'angular',
            unicode: 'f420'
        },
        {
            name: 'app-store',
            unicode: 'f36f'
        },
        {
            name: 'app-store-ios',
            unicode: 'f370'
        },
        {
            name: 'apper',
            unicode: 'f371'
        },
        {
            name: 'apple',
            unicode: 'f179'
        },
        {
            name: 'apple-pay',
            unicode: 'f415'
        },
        {
            name: 'artstation',
            unicode: 'f77a'
        },
        {
            name: 'asymmetrik',
            unicode: 'f372'
        },
        {
            name: 'atlassian',
            unicode: 'f77b'
        },
        {
            name: 'audible',
            unicode: 'f373'
        },
        {
            name: 'autoprefixer',
            unicode: 'f41c'
        },
        {
            name: 'avianex',
            unicode: 'f374'
        },
        {
            name: 'aviato',
            unicode: 'f421'
        },
        {
            name: 'aws',
            unicode: 'f375'
        },
        {
            name: 'bandcamp',
            unicode: 'f2d5'
        },
        {
            name: 'battle-net',
            unicode: 'f835'
        },
        {
            name: 'behance',
            unicode: 'f1b4'
        },
        {
            name: 'behance-square',
            unicode: 'f1b5'
        },
        {
            name: 'bimobject',
            unicode: 'f378'
        },
        {
            name: 'bitbucket',
            unicode: 'f171'
        },
        {
            name: 'bitcoin',
            unicode: 'f379'
        },
        {
            name: 'bity',
            unicode: 'f37a'
        },
        {
            name: 'black-tie',
            unicode: 'f27e'
        },
        {
            name: 'blackberry',
            unicode: 'f37b'
        },
        {
            name: 'blogger',
            unicode: 'f37c'
        },
        {
            name: 'blogger-b',
            unicode: 'f37d'
        },
        {
            name: 'bluetooth',
            unicode: 'f293'
        },
        {
            name: 'bluetooth-b',
            unicode: 'f294'
        },
        {
            name: 'bootstrap',
            unicode: 'f836'
        },
        {
            name: 'btc',
            unicode: 'f15a'
        },
        {
            name: 'buffer',
            unicode: 'f837'
        },
        {
            name: 'buromobelexperte',
            unicode: 'f37f'
        },
        {
            name: 'buy-n-large',
            unicode: 'f8a6'
        },
        {
            name: 'buysellads',
            unicode: 'f20d'
        },
        {
            name: 'canadian-maple-leaf',
            unicode: 'f785'
        },
        {
            name: 'cc-amazon-pay',
            unicode: 'f42d'
        },
        {
            name: 'cc-amex',
            unicode: 'f1f3'
        },
        {
            name: 'cc-apple-pay',
            unicode: 'f416'
        },
        {
            name: 'cc-diners-club',
            unicode: 'f24c'
        },
        {
            name: 'cc-discover',
            unicode: 'f1f2'
        },
        {
            name: 'cc-jcb',
            unicode: 'f24b'
        },
        {
            name: 'cc-mastercard',
            unicode: 'f1f1'
        },
        {
            name: 'cc-paypal',
            unicode: 'f1f4'
        },
        {
            name: 'cc-stripe',
            unicode: 'f1f5'
        },
        {
            name: 'cc-visa',
            unicode: 'f1f0'
        },
        {
            name: 'centercode',
            unicode: 'f380'
        },
        {
            name: 'centos',
            unicode: 'f789'
        },
        {
            name: 'chrome',
            unicode: 'f268'
        },
        {
            name: 'chromecast',
            unicode: 'f838'
        },
        {
            name: 'cloudscale',
            unicode: 'f383'
        },
        {
            name: 'cloudsmith',
            unicode: 'f384'
        },
        {
            name: 'cloudversify',
            unicode: 'f385'
        },
        {
            name: 'codepen',
            unicode: 'f1cb'
        },
        {
            name: 'codiepie',
            unicode: 'f284'
        },
        {
            name: 'confluence',
            unicode: 'f78d'
        },
        {
            name: 'connectdevelop',
            unicode: 'f20e'
        },
        {
            name: 'contao',
            unicode: 'f26d'
        },
        {
            name: 'cotton-bureau',
            unicode: 'f89e'
        },
        {
            name: 'cpanel',
            unicode: 'f388'
        },
        {
            name: 'creative-commons',
            unicode: 'f25e'
        },
        {
            name: 'creative-commons-by',
            unicode: 'f4e7'
        },
        {
            name: 'creative-commons-nc',
            unicode: 'f4e8'
        },
        {
            name: 'creative-commons-nc-eu',
            unicode: 'f4e9'
        },
        {
            name: 'creative-commons-nc-jp',
            unicode: 'f4ea'
        },
        {
            name: 'creative-commons-nd',
            unicode: 'f4eb'
        },
        {
            name: 'creative-commons-pd',
            unicode: 'f4ec'
        },
        {
            name: 'creative-commons-pd-alt',
            unicode: 'f4ed'
        },
        {
            name: 'creative-commons-remix',
            unicode: 'f4ee'
        },
        {
            name: 'creative-commons-sa',
            unicode: 'f4ef'
        },
        {
            name: 'creative-commons-sampling',
            unicode: 'f4f0'
        },
        {
            name: 'creative-commons-sampling-plus',
            unicode: 'f4f1'
        },
        {
            name: 'creative-commons-share',
            unicode: 'f4f2'
        },
        {
            name: 'creative-commons-zero',
            unicode: 'f4f3'
        },
        {
            name: 'critical-role',
            unicode: 'f6c9'
        },
        {
            name: 'css3',
            unicode: 'f13c'
        },
        {
            name: 'css3-alt',
            unicode: 'f38b'
        },
        {
            name: 'cuttlefish',
            unicode: 'f38c'
        },
        {
            name: 'd-and-d',
            unicode: 'f38d'
        },
        {
            name: 'd-and-d-beyond',
            unicode: 'f6ca'
        },
        {
            name: 'dailymotion',
            unicode: 'e052'
        },
        {
            name: 'dashcube',
            unicode: 'f210'
        },
        {
            name: 'deezer',
            unicode: 'e077'
        },
        {
            name: 'delicious',
            unicode: 'f1a5'
        },
        {
            name: 'deploydog',
            unicode: 'f38e'
        },
        {
            name: 'deskpro',
            unicode: 'f38f'
        },
        {
            name: 'dev',
            unicode: 'f6cc'
        },
        {
            name: 'deviantart',
            unicode: 'f1bd'
        },
        {
            name: 'dhl',
            unicode: 'f790'
        },
        {
            name: 'diaspora',
            unicode: 'f791'
        },
        {
            name: 'digg',
            unicode: 'f1a6'
        },
        {
            name: 'digital-ocean',
            unicode: 'f391'
        },
        {
            name: 'discord',
            unicode: 'f392'
        },
        {
            name: 'discourse',
            unicode: 'f393'
        },
        {
            name: 'dochub',
            unicode: 'f394'
        },
        {
            name: 'docker',
            unicode: 'f395'
        },
        {
            name: 'draft2digital',
            unicode: 'f396'
        },
        {
            name: 'dribbble',
            unicode: 'f17d'
        },
        {
            name: 'dribbble-square',
            unicode: 'f397'
        },
        {
            name: 'dropbox',
            unicode: 'f16b'
        },
        {
            name: 'drupal',
            unicode: 'f1a9'
        },
        {
            name: 'dyalog',
            unicode: 'f399'
        },
        {
            name: 'earlybirds',
            unicode: 'f39a'
        },
        {
            name: 'ebay',
            unicode: 'f4f4'
        },
        {
            name: 'edge',
            unicode: 'f282'
        },
        {
            name: 'edge-legacy',
            unicode: 'e078'
        },
        {
            name: 'elementor',
            unicode: 'f430'
        },
        {
            name: 'ello',
            unicode: 'f5f1'
        },
        {
            name: 'ember',
            unicode: 'f423'
        },
        {
            name: 'empire',
            unicode: 'f1d1'
        },
        {
            name: 'envira',
            unicode: 'f299'
        },
        {
            name: 'erlang',
            unicode: 'f39d'
        },
        {
            name: 'ethereum',
            unicode: 'f42e'
        },
        {
            name: 'etsy',
            unicode: 'f2d7'
        },
        {
            name: 'evernote',
            unicode: 'f839'
        },
        {
            name: 'expeditedssl',
            unicode: 'f23e'
        },
        {
            name: 'facebook',
            unicode: 'f09a'
        },
        {
            name: 'facebook-f',
            unicode: 'f39e'
        },
        {
            name: 'facebook-messenger',
            unicode: 'f39f'
        },
        {
            name: 'facebook-square',
            unicode: 'f082'
        },
        {
            name: 'fantasy-flight-games',
            unicode: 'f6dc'
        },
        {
            name: 'fedex',
            unicode: 'f797'
        },
        {
            name: 'fedora',
            unicode: 'f798'
        },
        {
            name: 'figma',
            unicode: 'f799'
        },
        {
            name: 'firefox',
            unicode: 'f269'
        },
        {
            name: 'firefox-browser',
            unicode: 'e007'
        },
        {
            name: 'first-order',
            unicode: 'f2b0'
        },
        {
            name: 'first-order-alt',
            unicode: 'f50a'
        },
        {
            name: 'firstdraft',
            unicode: 'f3a1'
        },
        {
            name: 'flickr',
            unicode: 'f16e'
        },
        {
            name: 'flipboard',
            unicode: 'f44d'
        },
        {
            name: 'fly',
            unicode: 'f417'
        },
        {
            name: 'font-awesome',
            unicode: 'f2b4'
        },
        {
            name: 'font-awesome-alt',
            unicode: 'f35c'
        },
        {
            name: 'font-awesome-flag',
            unicode: 'f425'
        },
        {
            name: 'font-awesome-logo-full',
            unicode: 'f4e6'
        },
        {
            name: 'fonticons',
            unicode: 'f280'
        },
        {
            name: 'fonticons-fi',
            unicode: 'f3a2'
        },
        {
            name: 'fort-awesome',
            unicode: 'f286'
        },
        {
            name: 'fort-awesome-alt',
            unicode: 'f3a3'
        },
        {
            name: 'forumbee',
            unicode: 'f211'
        },
        {
            name: 'foursquare',
            unicode: 'f180'
        },
        {
            name: 'free-code-camp',
            unicode: 'f2c5'
        },
        {
            name: 'freebsd',
            unicode: 'f3a4'
        },
        {
            name: 'fulcrum',
            unicode: 'f50b'
        },
        {
            name: 'galactic-republic',
            unicode: 'f50c'
        },
        {
            name: 'galactic-senate',
            unicode: 'f50d'
        },
        {
            name: 'get-pocket',
            unicode: 'f265'
        },
        {
            name: 'gg',
            unicode: 'f260'
        },
        {
            name: 'gg-circle',
            unicode: 'f261'
        },
        {
            name: 'git',
            unicode: 'f1d3'
        },
        {
            name: 'git-alt',
            unicode: 'f841'
        },
        {
            name: 'git-square',
            unicode: 'f1d2'
        },
        {
            name: 'github',
            unicode: 'f09b'
        },
        {
            name: 'github-alt',
            unicode: 'f113'
        },
        {
            name: 'github-square',
            unicode: 'f092'
        },
        {
            name: 'gitkraken',
            unicode: 'f3a6'
        },
        {
            name: 'gitlab',
            unicode: 'f296'
        },
        {
            name: 'gitter',
            unicode: 'f426'
        },
        {
            name: 'glide',
            unicode: 'f2a5'
        },
        {
            name: 'glide-g',
            unicode: 'f2a6'
        },
        {
            name: 'gofore',
            unicode: 'f3a7'
        },
        {
            name: 'goodreads',
            unicode: 'f3a8'
        },
        {
            name: 'goodreads-g',
            unicode: 'f3a9'
        },
        {
            name: 'google',
            unicode: 'f1a0'
        },
        {
            name: 'google-drive',
            unicode: 'f3aa'
        },
        {
            name: 'google-pay',
            unicode: 'e079'
        },
        {
            name: 'google-play',
            unicode: 'f3ab'
        },
        {
            name: 'google-plus',
            unicode: 'f2b3'
        },
        {
            name: 'google-plus-g',
            unicode: 'f0d5'
        },
        {
            name: 'google-plus-square',
            unicode: 'f0d4'
        },
        {
            name: 'google-wallet',
            unicode: 'f1ee'
        },
        {
            name: 'gratipay',
            unicode: 'f184'
        },
        {
            name: 'grav',
            unicode: 'f2d6'
        },
        {
            name: 'gripfire',
            unicode: 'f3ac'
        },
        {
            name: 'grunt',
            unicode: 'f3ad'
        },
        {
            name: 'gulp',
            unicode: 'f3ae'
        },
        {
            name: 'hacker-news',
            unicode: 'f1d4'
        },
        {
            name: 'hacker-news-square',
            unicode: 'f3af'
        },
        {
            name: 'hackerrank',
            unicode: 'f5f7'
        },
        {
            name: 'hips',
            unicode: 'f452'
        },
        {
            name: 'hire-a-helper',
            unicode: 'f3b0'
        },
        {
            name: 'hooli',
            unicode: 'f427'
        },
        {
            name: 'hornbill',
            unicode: 'f592'
        },
        {
            name: 'hotjar',
            unicode: 'f3b1'
        },
        {
            name: 'houzz',
            unicode: 'f27c'
        },
        {
            name: 'html5',
            unicode: 'f13b'
        },
        {
            name: 'hubspot',
            unicode: 'f3b2'
        },
        {
            name: 'ideal',
            unicode: 'e013'
        },
        {
            name: 'imdb',
            unicode: 'f2d8'
        },
        {
            name: 'instagram',
            unicode: 'f16d'
        },
        {
            name: 'instagram-square',
            unicode: 'e055'
        },
        {
            name: 'intercom',
            unicode: 'f7af'
        },
        {
            name: 'internet-explorer',
            unicode: 'f26b'
        },
        {
            name: 'invision',
            unicode: 'f7b0'
        },
        {
            name: 'ioxhost',
            unicode: 'f208'
        },
        {
            name: 'itch-io',
            unicode: 'f83a'
        },
        {
            name: 'itunes',
            unicode: 'f3b4'
        },
        {
            name: 'itunes-note',
            unicode: 'f3b5'
        },
        {
            name: 'java',
            unicode: 'f4e4'
        },
        {
            name: 'jedi-order',
            unicode: 'f50e'
        },
        {
            name: 'jenkins',
            unicode: 'f3b6'
        },
        {
            name: 'jira',
            unicode: 'f7b1'
        },
        {
            name: 'joget',
            unicode: 'f3b7'
        },
        {
            name: 'joomla',
            unicode: 'f1aa'
        },
        {
            name: 'js',
            unicode: 'f3b8'
        },
        {
            name: 'js-square',
            unicode: 'f3b9'
        },
        {
            name: 'jsfiddle',
            unicode: 'f1cc'
        },
        {
            name: 'kaggle',
            unicode: 'f5fa'
        },
        {
            name: 'keybase',
            unicode: 'f4f5'
        },
        {
            name: 'keycdn',
            unicode: 'f3ba'
        },
        {
            name: 'kickstarter',
            unicode: 'f3bb'
        },
        {
            name: 'kickstarter-k',
            unicode: 'f3bc'
        },
        {
            name: 'korvue',
            unicode: 'f42f'
        },
        {
            name: 'laravel',
            unicode: 'f3bd'
        },
        {
            name: 'lastfm',
            unicode: 'f202'
        },
        {
            name: 'lastfm-square',
            unicode: 'f203'
        },
        {
            name: 'leanpub',
            unicode: 'f212'
        },
        {
            name: 'less',
            unicode: 'f41d'
        },
        {
            name: 'line',
            unicode: 'f3c0'
        },
        {
            name: 'linkedin',
            unicode: 'f08c'
        },
        {
            name: 'linkedin-in',
            unicode: 'f0e1'
        },
        {
            name: 'linode',
            unicode: 'f2b8'
        },
        {
            name: 'linux',
            unicode: 'f17c'
        },
        {
            name: 'lyft',
            unicode: 'f3c3'
        },
        {
            name: 'magento',
            unicode: 'f3c4'
        },
        {
            name: 'mailchimp',
            unicode: 'f59e'
        },
        {
            name: 'mandalorian',
            unicode: 'f50f'
        },
        {
            name: 'markdown',
            unicode: 'f60f'
        },
        {
            name: 'mastodon',
            unicode: 'f4f6'
        },
        {
            name: 'maxcdn',
            unicode: 'f136'
        },
        {
            name: 'mdb',
            unicode: 'f8ca'
        },
        {
            name: 'medapps',
            unicode: 'f3c6'
        },
        {
            name: 'medium',
            unicode: 'f23a'
        },
        {
            name: 'medium-m',
            unicode: 'f3c7'
        },
        {
            name: 'medrt',
            unicode: 'f3c8'
        },
        {
            name: 'meetup',
            unicode: 'f2e0'
        },
        {
            name: 'megaport',
            unicode: 'f5a3'
        },
        {
            name: 'mendeley',
            unicode: 'f7b3'
        },
        {
            name: 'microblog',
            unicode: 'e01a'
        },
        {
            name: 'microsoft',
            unicode: 'f3ca'
        },
        {
            name: 'mix',
            unicode: 'f3cb'
        },
        {
            name: 'mixcloud',
            unicode: 'f289'
        },
        {
            name: 'mixer',
            unicode: 'e056'
        },
        {
            name: 'mizuni',
            unicode: 'f3cc'
        },
        {
            name: 'modx',
            unicode: 'f285'
        },
        {
            name: 'monero',
            unicode: 'f3d0'
        },
        {
            name: 'napster',
            unicode: 'f3d2'
        },
        {
            name: 'neos',
            unicode: 'f612'
        },
        {
            name: 'nimblr',
            unicode: 'f5a8'
        },
        {
            name: 'node',
            unicode: 'f419'
        },
        {
            name: 'node-js',
            unicode: 'f3d3'
        },
        {
            name: 'npm',
            unicode: 'f3d4'
        },
        {
            name: 'ns8',
            unicode: 'f3d5'
        },
        {
            name: 'nutritionix',
            unicode: 'f3d6'
        },
        {
            name: 'odnoklassniki',
            unicode: 'f263'
        },
        {
            name: 'odnoklassniki-square',
            unicode: 'f264'
        },
        {
            name: 'old-republic',
            unicode: 'f510'
        },
        {
            name: 'opencart',
            unicode: 'f23d'
        },
        {
            name: 'openid',
            unicode: 'f19b'
        },
        {
            name: 'opera',
            unicode: 'f26a'
        },
        {
            name: 'optin-monster',
            unicode: 'f23c'
        },
        {
            name: 'orcid',
            unicode: 'f8d2'
        },
        {
            name: 'osi',
            unicode: 'f41a'
        },
        {
            name: 'page4',
            unicode: 'f3d7'
        },
        {
            name: 'pagelines',
            unicode: 'f18c'
        },
        {
            name: 'palfed',
            unicode: 'f3d8'
        },
        {
            name: 'patreon',
            unicode: 'f3d9'
        },
        {
            name: 'paypal',
            unicode: 'f1ed'
        },
        {
            name: 'penny-arcade',
            unicode: 'f704'
        },
        {
            name: 'periscope',
            unicode: 'f3da'
        },
        {
            name: 'phabricator',
            unicode: 'f3db'
        },
        {
            name: 'phoenix-framework',
            unicode: 'f3dc'
        },
        {
            name: 'phoenix-squadron',
            unicode: 'f511'
        },
        {
            name: 'php',
            unicode: 'f457'
        },
        {
            name: 'pied-piper',
            unicode: 'f2ae'
        },
        {
            name: 'pied-piper-alt',
            unicode: 'f1a8'
        },
        {
            name: 'pied-piper-hat',
            unicode: 'f4e5'
        },
        {
            name: 'pied-piper-pp',
            unicode: 'f1a7'
        },
        {
            name: 'pied-piper-square',
            unicode: 'e01e'
        },
        {
            name: 'pinterest',
            unicode: 'f0d2'
        },
        {
            name: 'pinterest-p',
            unicode: 'f231'
        },
        {
            name: 'pinterest-square',
            unicode: 'f0d3'
        },
        {
            name: 'playstation',
            unicode: 'f3df'
        },
        {
            name: 'product-hunt',
            unicode: 'f288'
        },
        {
            name: 'pushed',
            unicode: 'f3e1'
        },
        {
            name: 'python',
            unicode: 'f3e2'
        },
        {
            name: 'qq',
            unicode: 'f1d6'
        },
        {
            name: 'quinscape',
            unicode: 'f459'
        },
        {
            name: 'quora',
            unicode: 'f2c4'
        },
        {
            name: 'r-project',
            unicode: 'f4f7'
        },
        {
            name: 'raspberry-pi',
            unicode: 'f7bb'
        },
        {
            name: 'ravelry',
            unicode: 'f2d9'
        },
        {
            name: 'react',
            unicode: 'f41b'
        },
        {
            name: 'reacteurope',
            unicode: 'f75d'
        },
        {
            name: 'readme',
            unicode: 'f4d5'
        },
        {
            name: 'rebel',
            unicode: 'f1d0'
        },
        {
            name: 'red-river',
            unicode: 'f3e3'
        },
        {
            name: 'reddit',
            unicode: 'f1a1'
        },
        {
            name: 'reddit-alien',
            unicode: 'f281'
        },
        {
            name: 'reddit-square',
            unicode: 'f1a2'
        },
        {
            name: 'redhat',
            unicode: 'f7bc'
        },
        {
            name: 'renren',
            unicode: 'f18b'
        },
        {
            name: 'replyd',
            unicode: 'f3e6'
        },
        {
            name: 'researchgate',
            unicode: 'f4f8'
        },
        {
            name: 'resolving',
            unicode: 'f3e7'
        },
        {
            name: 'rev',
            unicode: 'f5b2'
        },
        {
            name: 'rocketchat',
            unicode: 'f3e8'
        },
        {
            name: 'rockrms',
            unicode: 'f3e9'
        },
        {
            name: 'rust',
            unicode: 'e07a'
        },
        {
            name: 'safari',
            unicode: 'f267'
        },
        {
            name: 'salesforce',
            unicode: 'f83b'
        },
        {
            name: 'sass',
            unicode: 'f41e'
        },
        {
            name: 'schlix',
            unicode: 'f3ea'
        },
        {
            name: 'scribd',
            unicode: 'f28a'
        },
        {
            name: 'searchengin',
            unicode: 'f3eb'
        },
        {
            name: 'sellcast',
            unicode: 'f2da'
        },
        {
            name: 'sellsy',
            unicode: 'f213'
        },
        {
            name: 'servicestack',
            unicode: 'f3ec'
        },
        {
            name: 'shirtsinbulk',
            unicode: 'f214'
        },
        {
            name: 'shopify',
            unicode: 'e057'
        },
        {
            name: 'shopware',
            unicode: 'f5b5'
        },
        {
            name: 'simplybuilt',
            unicode: 'f215'
        },
        {
            name: 'sistrix',
            unicode: 'f3ee'
        },
        {
            name: 'sith',
            unicode: 'f512'
        },
        {
            name: 'sketch',
            unicode: 'f7c6'
        },
        {
            name: 'skyatlas',
            unicode: 'f216'
        },
        {
            name: 'skype',
            unicode: 'f17e'
        },
        {
            name: 'slack',
            unicode: 'f198'
        },
        {
            name: 'slack-hash',
            unicode: 'f3ef'
        },
        {
            name: 'slideshare',
            unicode: 'f1e7'
        },
        {
            name: 'snapchat',
            unicode: 'f2ab'
        },
        {
            name: 'snapchat-ghost',
            unicode: 'f2ac'
        },
        {
            name: 'snapchat-square',
            unicode: 'f2ad'
        },
        {
            name: 'soundcloud',
            unicode: 'f1be'
        },
        {
            name: 'sourcetree',
            unicode: 'f7d3'
        },
        {
            name: 'speakap',
            unicode: 'f3f3'
        },
        {
            name: 'speaker-deck',
            unicode: 'f83c'
        },
        {
            name: 'spotify',
            unicode: 'f1bc'
        },
        {
            name: 'squarespace',
            unicode: 'f5be'
        },
        {
            name: 'stack-exchange',
            unicode: 'f18d'
        },
        {
            name: 'stack-overflow',
            unicode: 'f16c'
        },
        {
            name: 'stackpath',
            unicode: 'f842'
        },
        {
            name: 'staylinked',
            unicode: 'f3f5'
        },
        {
            name: 'steam',
            unicode: 'f1b6'
        },
        {
            name: 'steam-square',
            unicode: 'f1b7'
        },
        {
            name: 'steam-symbol',
            unicode: 'f3f6'
        },
        {
            name: 'sticker-mule',
            unicode: 'f3f7'
        },
        {
            name: 'strava',
            unicode: 'f428'
        },
        {
            name: 'stripe',
            unicode: 'f429'
        },
        {
            name: 'stripe-s',
            unicode: 'f42a'
        },
        {
            name: 'studiovinari',
            unicode: 'f3f8'
        },
        {
            name: 'stumbleupon',
            unicode: 'f1a4'
        },
        {
            name: 'stumbleupon-circle',
            unicode: 'f1a3'
        },
        {
            name: 'superpowers',
            unicode: 'f2dd'
        },
        {
            name: 'supple',
            unicode: 'f3f9'
        },
        {
            name: 'suse',
            unicode: 'f7d6'
        },
        {
            name: 'swift',
            unicode: 'f8e1'
        },
        {
            name: 'symfony',
            unicode: 'f83d'
        },
        {
            name: 'teamspeak',
            unicode: 'f4f9'
        },
        {
            name: 'telegram',
            unicode: 'f2c6'
        },
        {
            name: 'telegram-plane',
            unicode: 'f3fe'
        },
        {
            name: 'tencent-weibo',
            unicode: 'f1d5'
        },
        {
            name: 'the-red-yeti',
            unicode: 'f69d'
        },
        {
            name: 'themeco',
            unicode: 'f5c6'
        },
        {
            name: 'themeisle',
            unicode: 'f2b2'
        },
        {
            name: 'think-peaks',
            unicode: 'f731'
        },
        {
            name: 'tiktok',
            unicode: 'e07b'
        },
        {
            name: 'trade-federation',
            unicode: 'f513'
        },
        {
            name: 'trello',
            unicode: 'f181'
        },
        {
            name: 'tripadvisor',
            unicode: 'f262'
        },
        {
            name: 'tumblr',
            unicode: 'f173'
        },
        {
            name: 'tumblr-square',
            unicode: 'f174'
        },
        {
            name: 'twitch',
            unicode: 'f1e8'
        },
        {
            name: 'twitter',
            unicode: 'f099'
        },
        {
            name: 'twitter-square',
            unicode: 'f081'
        },
        {
            name: 'typo3',
            unicode: 'f42b'
        },
        {
            name: 'uber',
            unicode: 'f402'
        },
        {
            name: 'ubuntu',
            unicode: 'f7df'
        },
        {
            name: 'uikit',
            unicode: 'f403'
        },
        {
            name: 'umbraco',
            unicode: 'f8e8'
        },
        {
            name: 'uniregistry',
            unicode: 'f404'
        },
        {
            name: 'unity',
            unicode: 'e049'
        },
        {
            name: 'unsplash',
            unicode: 'e07c'
        },
        {
            name: 'untappd',
            unicode: 'f405'
        },
        {
            name: 'ups',
            unicode: 'f7e0'
        },
        {
            name: 'usb',
            unicode: 'f287'
        },
        {
            name: 'usps',
            unicode: 'f7e1'
        },
        {
            name: 'ussunnah',
            unicode: 'f407'
        },
        {
            name: 'vaadin',
            unicode: 'f408'
        },
        {
            name: 'viacoin',
            unicode: 'f237'
        },
        {
            name: 'viadeo',
            unicode: 'f2a9'
        },
        {
            name: 'viadeo-square',
            unicode: 'f2aa'
        },
        {
            name: 'viber',
            unicode: 'f409'
        },
        {
            name: 'vimeo',
            unicode: 'f40a'
        },
        {
            name: 'vimeo-square',
            unicode: 'f194'
        },
        {
            name: 'vimeo-v',
            unicode: 'f27d'
        },
        {
            name: 'vine',
            unicode: 'f1ca'
        },
        {
            name: 'vk',
            unicode: 'f189'
        },
        {
            name: 'vnv',
            unicode: 'f40b'
        },
        {
            name: 'vuejs',
            unicode: 'f41f'
        },
        {
            name: 'waze',
            unicode: 'f83f'
        },
        {
            name: 'weebly',
            unicode: 'f5cc'
        },
        {
            name: 'weibo',
            unicode: 'f18a'
        },
        {
            name: 'weixin',
            unicode: 'f1d7'
        },
        {
            name: 'whatsapp',
            unicode: 'f232'
        },
        {
            name: 'whatsapp-square',
            unicode: 'f40c'
        },
        {
            name: 'whmcs',
            unicode: 'f40d'
        },
        {
            name: 'wikipedia-w',
            unicode: 'f266'
        },
        {
            name: 'windows',
            unicode: 'f17a'
        },
        {
            name: 'wix',
            unicode: 'f5cf'
        },
        {
            name: 'wizards-of-the-coast',
            unicode: 'f730'
        },
        {
            name: 'wolf-pack-battalion',
            unicode: 'f514'
        },
        {
            name: 'wordpress',
            unicode: 'f19a'
        },
        {
            name: 'wordpress-simple',
            unicode: 'f411'
        },
        {
            name: 'wpbeginner',
            unicode: 'f297'
        },
        {
            name: 'wpexplorer',
            unicode: 'f2de'
        },
        {
            name: 'wpforms',
            unicode: 'f298'
        },
        {
            name: 'wpressr',
            unicode: 'f3e4'
        },
        {
            name: 'xbox',
            unicode: 'f412'
        },
        {
            name: 'xing',
            unicode: 'f168'
        },
        {
            name: 'xing-square',
            unicode: 'f169'
        },
        {
            name: 'y-combinator',
            unicode: 'f23b'
        },
        {
            name: 'yahoo',
            unicode: 'f19e'
        },
        {
            name: 'yammer',
            unicode: 'f840'
        },
        {
            name: 'yandex',
            unicode: 'f413'
        },
        {
            name: 'yandex-international',
            unicode: 'f414'
        },
        {
            name: 'yarn',
            unicode: 'f7e3'
        },
        {
            name: 'yelp',
            unicode: 'f1e9'
        },
        {
            name: 'yoast',
            unicode: 'f2b1'
        },
        {
            name: 'youtube',
            unicode: 'f167'
        },
        {
            name: 'youtube-square',
            unicode: 'f431'
        },
        {
            name: 'zhihu',
            unicode: 'f63f'
        }
    ]
};
